let app = angular.module('galilai.creator', ['ngSanitize']);

function uuidV4() {
    const uuid = new Array(36);
    for (let i = 0; i < 36; i++) {
        uuid[i] = Math.floor(Math.random() * 16);
    }
    uuid[14] = 4; // set bits 12-15 of time-high-and-version to 0100
    uuid[19] = uuid[19] &= ~(1 << 2); // set bit 6 of clock-seq-and-reserved to zero
    uuid[19] = uuid[19] |= (1 << 3); // set bit 7 of clock-seq-and-reserved to one
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    return uuid.map((x) => x.toString(16)).join('');
}

const DEBUG = false
const IS_APP = window.IS_APP || false
let CURRENT_OS = 'web'
if (IS_APP && window.navigator && window.navigator.userAgent) {
    CURRENT_OS = window.navigator.userAgent.toLowerCase().indexOf('android') > -1 ? 'android' : 'ios'
}
const IS_IOS = CURRENT_OS == 'ios'
const IS_ANDROID = CURRENT_OS == 'android'

const SMART_LAYOUTS_PREFIX = 's-'
window.BASE_URL = window.origin
window.RUN_ID = uuidV4()


function openOrReplaceURL(url) {
    if (IS_APP) {
        window.open(url, '_system')
    } else {
        window.location = url
    }
}
window.addEventListener('message', function (e) {
    if (e.data.name === 'redirectURL') {
        openOrReplaceURL(e.data.url)
    }
    if (e.data.name === 'reloadLocation') {
        window.location.reload()
    }
})

function changeURL(url) {
    if (window.self !== window.top) {
        window.parent.postMessage({
            name: 'redirectURL',
            url: url
        }, '*')
    } else {
        openOrReplaceURL(url)
    }
}

function goToEditor() {
    if (window.location.origin == 'https://galilai.com.br') {
        changeURL('https://galilai.com.br/editor-magico')
    } else {
        changeURL(window.BASE_URL + '/magic-editor')
    }
}

function reloadLocation(shouldWait) {
    function doReload() {
        if (window.self !== window.top) {
            window.parent.postMessage({
                name: 'reloadLocation'
            }, '*')
        } else {
            window.location.reload()
        }
    }

    if (shouldWait) {
        setTimeout(doReload, 500)
    } else {
        doReload()
    }
}

function configureBaseURL() {
    if (!IS_APP) {
        return
    }
    const fullLanguage = navigator.language || navigator.userLanguage
    const language = fullLanguage.split('-')[0]
    if (language == 'pt') {
        window.BASE_URL = 'https://galilai.com.br'
    } else {
        window.BASE_URL = 'https://galil.ai'
    }
}
configureBaseURL()

function safeSetStorage(key, value) {
    try {
        localStorage.setItem(key, value)
    } catch (e) { }
}

function safeGetStorage(key) {
    try {
        return localStorage.getItem(key)
    } catch (e) {
        return null
    }
}

function safeGetIntFromStorage(key, defaultValue) {
    try {
        let value = localStorage.getItem(key)
        if (value === null) {
            return defaultValue
        }
        value = parseInt(value)
        if (isNaN(value)) {
            return defaultValue
        }
        return value
    } catch (e) {
        return defaultValue
    }
}
// Function to get a cookie by name
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

// Function to set a cookie with a specific expiration date
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/`;
}

function getLocaleDate(date) {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2)
}

function detectCountry() {
    try {
        if (!getCookie("galilai.country")) {
            fetch("https://ipinfo.io?token=622b57e2fb326a")
                .then(response => response.json())
                .then(data => {
                    const country = data.country;
                    if (country) {
                        setCookie("galilai.country", country, 30);
                    }
                })
                .catch(error => console.error("Error fetching country:", error));
        }
    } catch (error) {
        console.error("Error detecting country:", error);
    }
}

function getCurrentCurrency() {
    if (!getCookie("galilai.country")) {
        return
    }
    const country = getCookie("galilai.country");

    return countriesToCurrency[country]?.currency
}

function getCurrentCountry() {
    if (!getCookie("galilai.country")) {
        return
    }
    return getCookie("galilai.country")
}

detectCountry()

function sendMessageWithCallback(message) {
    return new Promise((resolve) => {
        // Generate a unique message ID
        var messageId = Math.random().toString(36).substring(10);
        message.id = messageId;

        let container = window
        if (window.self !== window.top) {
            container = window.parent
        }
        // Send the message
        container.postMessage(message, '*');

        // Define the callback listener
        function callbackListener(event) {
            // Check if the response matches the message ID and kind
            if (event.data.id === messageId && event.data.kind === 'response') {
                // Remove the listener once we get the response
                window.removeEventListener('message', callbackListener);
                // Resolve the promise with the response data
                resolve(event.data);
            }
        }

        // Add the listener for message events
        window.addEventListener('message', callbackListener);
    });
}

function safeSetObject(obj, key, value) {
    if (!key || !obj) return;

    var parts = key.split('.');
    var current = obj;

    for (var i = 0; i < parts.length; i++) {
        var part = parts[i];

        // If it's the last key → set value
        if (i === parts.length - 1) {
            current[part] = value;
        } else {
            // If path doesn't exist or isn't an object → create it
            if (
                typeof current[part] !== 'object' ||
                current[part] === null
            ) {
                current[part] = {};
            }

            current = current[part];
        }
    }
}
function fullcopy(obj) {
    return JSON.parse(JSON.stringify(obj))
}

function toBinary(string) {
    return window.btoa(encodeURIComponent(string))
}

function fromBinary(encoded) {
    return decodeURIComponent(window.atob(encoded))
}
function isValidNumber(value) {
    if (typeof value === 'undefined' && value !== null) {
        return false
    }
    if (isNaN(parseFloat(value))) {
        return false
    }
    return true
}

function getValidNumber(value, defaultValue) {
    if (!isValidNumber(value)) {
        return defaultValue
    }
    return parseFloat(value)
}

let lastDebugMessageTime = {}
function _d(message) {
    if (!DEBUG) {
        return
    }
    document.getElementById('debug').innerHTML += 'Info: ' + message + '<br>'
}
function _dstart(message) {
    if (!DEBUG) {
        return
    }
    lastDebugMessageTime[message] = performance.now()
    document.getElementById('debug').innerHTML += 'Start: ' + message + '<br>'
}
function _dend(message) {
    if (!DEBUG) {
        return
    }
    let time = performance.now() - lastDebugMessageTime[message]
    document.getElementById('debug').innerHTML += 'Finish: ' + message + ' [' + time.toFixed(0) + 'ms]<br>'
}
function chooseWithHash(array, seed) {
    seed = seed + '' // Ensure seed is a string
    let hash = seed.split('').reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0)
    hash = Math.abs(hash)
    return array[hash % array.length]
}

function getLayoutParentId(layout) {
    if (!layout) {
        return null
    }
    let label = layout.label
    if (!label) {
        return null
    }
    if (!label.startsWith('d-')) {
        return null
    }
    let parentId = label.substring(2).split('.')[0]
    return parentId
}

function getUserLoginForm(email) {
    let inputForm = {
        email: email,
        meta: {},
    };

    try {
        inputForm.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        console.log(e);
    }

    let instagram = localStorage.getItem('auth.user.instagram');
    if (instagram) {
        inputForm.meta.instagram = instagram;
    }

    let area = localStorage.getItem('auth.user.area');
    if (area) {
        inputForm.meta.area = area;
    }

    try {
        let uuid = localStorage.getItem('galilai.uuid');
        if (uuid) {
            inputForm.meta.uuid = uuid;
        }
    } catch (e) {
        console.log(e);
    }

    try {
        let coupon = localStorage.getItem('galilai.coupon');
        if (coupon) {
            inputForm.meta.coupon = coupon;
        }
    } catch (e) {
        console.log(e);
    }

    return inputForm;
}

const BASE_THEME = {
    pallete: {
        main: '#03a9f4',
        text: '#e1f5fe',
        highlight: '#033349'
    },
    fonts: {
        primary: 'Manrope',
        secondary: 'Open Sans',
    },
    size: {
        width: 1,
        height: 1.25
    },
    defaults: {
        titleSize: 2,
        descriptionSize: 1,
        titleMinSize: 1.5,
        descriptionMinSize: 0.8,
    },
    settings: {},
}

// Feed posts can be 4:5 (1.25) or 3:4 (1.3333); anything taller is a story. Code that resets a feed
// post to 4:5 must leave a 3:4 one alone, or the size the person picked is lost on the next save.
const FEED_34_SIZE = { id: 'portrait34', width: 1, height: 1.333333333333 }
function isFeedPortraitHeight(height) {
    return height > 1.2 && height < 1.5
}

const MAP_POST_SIZES = {
    'reels': {
        width: 1,
        height: 1.777777777778
    },
    'story': {
        width: 1,
        height: 1.777777777778
    },
    'post': {
        width: 1,
        height: 1.25
    }
}

function getBaseTheme() {
    return JSON.parse(JSON.stringify(BASE_THEME))
}

const _PLANS = {
    BASIC: 'basic',
    PLUS: 'pro',
    PRO: 'premium',
    MAX: 'max',
    SHOP: 'shop',
    ADS: 'ads',
    INFINITE: 'infinite',
}

function getPlansName(plan) {
    switch (plan) {
        case _PLANS.BASIC:
            return 'Basic'
        case _PLANS.PLUS:
            return 'Plus'
        case _PLANS.PRO:
            return 'Pro'
        case _PLANS.MAX:
            return 'Max'
        case _PLANS.SHOP:
            return 'Shop'
        case _PLANS.ADS:
            return 'Ads'
        case _PLANS.INFINITE:
            return 'Infinite'
    }
    return 'Unknown'
}

String.prototype.stripHtml = function () {
    return this.replace(/<[^>]*>?/gm, '');
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}

const contentItemAttributes = [
    'mutant',
    'meta',
    'settings',
    'person',
    'element',
]
const specialAttributes = {
    'cta': '👉',
    'badge': "\\.",
    'address': '📍',
    'phone': '📞',
    'discount': '🏷️',
    'price': '💰',
}

function fixCommonEmailTypos(email) {
    const commonTypos = {
        'gmail.com': ['gamil.com', 'gmai.com', 'gmail.co', 'gmailcom', 'gmil.com', 'gmal.com', 'gmaill.com', 'gmaillcom', 'gmaill.co', 'gmaillco', 'gmai.co', 'gmail.con', 'gmail', 'gamil', 'gmil', 'gmal', 'gmaill', 'gmial.com', 'gmial'],
        'yahoo.com': ['yaho.com', 'yaoo.com', 'yahoi.com', 'yahho.com', 'yahooo.com', 'yahoo.co', 'yahoo.con', 'yahoo'],
        'outlook.com': ['outlok.com', 'outloook.com', 'outlook.co', 'outlokcom', 'outloookcom', 'outlookco', 'outlook.con', 'outlook'],
        'hotmail.com': ['hotmai.com', 'hotmal.com', 'hotmail.con', 'hotmail', 'hotmai', 'hotmal'],
    };

    const emailParts = email.split('@');
    if (emailParts.length !== 2) {
        return null
    }

    const domain = emailParts[1];
    for (const correctDomain in commonTypos) {
        if (commonTypos[correctDomain].indexOf(domain) !== -1) {
            return emailParts[0] + '@' + correctDomain;
        }
    }
    // If emails end with .con, replace with .com
    if (domain.endsWith('.con')) {
        return emailParts[0] + '@' + domain.replace('.con', '.com');
    }

    return email;
}

function isMobileDevice() {
  const isMobileUA = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isSmallScreen = window.innerWidth <= 768;
  return isMobileUA || isSmallScreen;
}

app.config(function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
});

app.filter('trusted', function ($sce) {
    return function (html) {
        return $sce.trustAsHtml(html)
    }
})

// ng-src on <video> goes through $sce as a RESOURCE_URL and a plain string is rejected —
// without this the video simply does not render, with no visible error
app.filter('trustedResource', function ($sce) {
    return function (url) {
        return $sce.trustAsResourceUrl(url)
    }
})

const FORCE_START_TRIAL_PRO = false
app.factory('experiments', function () {
    let experiments = {}

    let activeExperiments = [
        //'improved-headlines',
        //'calendar',
        //'show-plans-instead-trial',
        // Enabled 10/09
        'start-trial-pro',
        'plans-period-monthly',
    ]
    let showOfferOnMobile = false
    // Check if location has promo param
    let isPromo = false
    if (FORCE_START_TRIAL_PRO) {
        safeSetStorage('galilai.experiment.start-trial-pro', 'B')
    }
    try {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('promo')) {
            isPromo = true
            safeSetStorage('galilai.experiment.paid-trial-offer', 'B')
        }
        // Check if offer enabled
        if ((showOfferOnMobile && isMobileDevice() && !IS_APP) || isPromo) {
            // Remove 'show-plans-instead-trial', add paid-trial-offer
            activeExperiments = activeExperiments.filter(e => e != 'show-plans-instead-trial')
            activeExperiments.push('paid-trial-offer')
        }
    } catch (e) { }

    experiments.isVariant = function (name) {
        // Force result
        // Check if name is in active experiments
        if (activeExperiments.indexOf(name) == -1) {
            return false
        }
        try {
            let variant = localStorage.getItem('galilai.experiment.' + name)
            if (variant) {
                return variant.toLowerCase() == 'b'
            }
        } catch (e) {
            logError({
                messsage: 'Experiment error',
                error: e
            })
        }
        return false
    }

    experiments.setupExperiments = function () {
        try {
            // For all active experiments save local storage Math.random weather the user is in the variant or not
            for (let experiment of activeExperiments) {
                let variant = localStorage.getItem('galilai.experiment.' + experiment)
                if (!variant) {
                    variant = Math.random() < 0.5 ? 'A' : 'B'
                    localStorage.setItem('galilai.experiment.' + experiment, variant)
                }
            }
        } catch (e) {
            logError({
                messsage: 'Setup experiments error',
                error: e
            })
        }
    }
    experiments.getTrackInfo = function () {
        let info = {}
        try {
            for (let experiment of activeExperiments) {
                let variant = localStorage.getItem('galilai.experiment.' + experiment)
                if (!variant) {
                    variant = 'none'
                }
                info[experiment] = variant
            }
        } catch (e) {
            logError({
                messsage: 'Get track info error',
                error: e
            })
        }
        return info
    }
    return experiments
})

app.filter("reverse", function () {
    return function (items) {
        return items.slice().reverse();
    };
});

app.directive('cssVars', function () {
    return {
      restrict: 'A',
      scope: {
        cssVars: '=' // two-way so updates re-apply
      },
      link: function (scope, element) {
        var el = element[0];

        function applyVars(obj) {
          if (!obj) { return; }
          // set or remove only the keys you pass; does NOT overwrite other inline styles
          for (var key in obj) {
            if (!obj.hasOwnProperty(key)) { continue; }
            var val = obj[key];
            if (val === null || typeof val === 'undefined' || val === '') {
              el.style.removeProperty(key);
            } else {
              el.style.setProperty(key, val);
            }
          }
        }

        // initial
        applyVars(scope.cssVars);

        // react to changes (deep)
        scope.$watch('cssVars', function (n) {
          applyVars(n);
        }, true);
      }
    };
});

app.directive('reorderList', function () {
    return {
        restrict: 'E',
        scope: {
            items: '=',
            onChange: '&'
        },
        template:
            '<ul class="list-group">' +
                '<li class="list-group-item d-flex justify-content-between align-items-center"' +
                    ' ng-repeat="item in items track by item._originalIndex">' +

                    '<span>[[ item.text ]]</span>' +

                    '<div class="btn-group btn-group-sm">' +
                        '<button class="btn btn-outline-secondary"' +
                            ' ng-click="moveUp($index)"' +
                            ' ng-disabled="$index === 0">↑</button>' +

                        '<button class="btn btn-outline-secondary"' +
                            ' ng-click="moveDown($index)"' +
                            ' ng-disabled="$index === items.length - 1">↓</button>' +
                    '</div>' +

                '</li>' +
            '</ul>',

        link: function (scope) {

            scope.moveUp = function (index) {
                if (index === 0) {
                    return;
                }

                swap(index, index - 1);
            };

            scope.moveDown = function (index) {
                if (index === scope.items.length - 1) {
                    return;
                }

                swap(index, index + 1);
            };

            function swap(from, to) {
                var temp = scope.items[from];
                scope.items[from] = scope.items[to];
                scope.items[to] = temp;

                notifyChange();
            }

            function notifyChange() {
                var map = {};

                scope.items.forEach(function (item, newIndex) {
                    map[item._originalIndex] = newIndex;
                });

                scope.onChange({ map: map });
            }
        }
    };
});

app.directive('autoAdjustModal', function($timeout) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var modal = element[0];
            var resizeHandler = adjustModal;

            let debounceTimeout= null;
            function adjustModal() {
                if (debounceTimeout) {
                    $timeout.cancel(debounceTimeout);
                }
                debounceTimeout = $timeout(function() {
                    var mediaScrollWrapper = modal.querySelector('.content-scroll-wrapper');
                    if (!mediaScrollWrapper) return;

                    var windowHeight = window.innerHeight;
                    var offset = 200;
                    if (window.IS_APP) offset += 60;

                    if (mediaScrollWrapper.scrollHeight > windowHeight - offset) {
                        mediaScrollWrapper.style.maxHeight = (windowHeight - offset) + 'px';
                        mediaScrollWrapper.style.overflowY = 'scroll';
                    } else {
                        mediaScrollWrapper.style.maxHeight = 'none';
                        mediaScrollWrapper.style.overflowY = 'visible';
                    }
                }, 200);
            }

            // When modal is shown, attach resize listener
            modal.addEventListener('shown.bs.modal', function() {
                adjustModal();
                window.addEventListener('resize', resizeHandler);
            });

            // When modal is hidden, detach resize listener
            modal.addEventListener('hidden.bs.modal', function() {
                window.removeEventListener('resize', resizeHandler);
            });

            // Cleanup if directive destroyed
            scope.$on('$destroy', function() {
                window.removeEventListener('resize', resizeHandler);
            });
        }
    };
});

app.directive('selectionModal', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            items: '=',
            visible: '=',
            title: '@',
            onConfirm: '&'
        },
        template: `
      <div class="modal fade" style="z-index:1000000;" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">{{title}}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <div class="list-group">

                <a href=""
                   class="list-group-item"
                   ng-repeat="item in items"
                   ng-click="select(item)">

                   <div style="display:flex;gap:10px;align-items:flex-start">
                     <i class="mdi {{item.icon}}" style="font-size:22px"></i>

                     <div style="flex:1">

                       <div>
                         <strong>{{item.title}}</strong>
                       </div>

                       <small class="text-muted d-block" style="margin-top:4px">
                         {{item.description}}
                       </small>


                       <div ng-if="item.badge" style="margin-top:4px">
                         <span class="badge bg-{{item.badge.color}}">
                           {{item.badge.label}}
                         </span>
                       </div>

                     </div>
                   </div>

                </a>

              </div>
            </div>

          </div>
        </div>
      </div>
    `,
        link: function (scope, element) {

            var modal = element.find('.modal');

            scope.$watch('visible', function (value) {

                if (value) {
                    $timeout(function () {
                        modal.modal('show');
                    });
                } else {
                    modal.modal('hide');
                }

            });

            modal.on('hidden.bs.modal', function () {
                scope.$apply(function () {
                    scope.visible = false;
                });
            });

            scope.select = function (item) {

                if (scope.onConfirm) {
                    scope.onConfirm({ item: item });
                }

                scope.visible = false;
            };

            scope.close = function () {
                scope.visible = false;
            };

        }
    };
});


app.directive('groupedSelectionModal', function ($timeout) {
  return {
    restrict: 'E',
    scope: {
      groups: '=',
      visible: '=',
      title: '@',
      onSelect: '&'
    },
    template: `
<div class="modal fade" style="z-index:1000000;" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
        <button type="button" class="btn-close" ng-click="close()"></button>
      </div>

      <div class="modal-body">

        <div ng-repeat="group in groups" class="mb-4">

          <div class="mb-2" style="display:flex;align-items:center;gap:10px">
            <i ng-class="'text-' + group.color" class="mdi {{group.icon}}" style="font-size:20px"></i>
            <strong ng-class="'text-' + group.color">{{group.title}}</strong>
            <span class="text-muted">{{group.subtitle}}</span>
          </div>

          <div class="list-group">

            <a href="javascript:void(0)"
               class="list-group-item"
               ng-repeat="item in group.items"
               ng-click="select(item)">

              <div style="display:flex;gap:12px;align-items:flex-start">

                <div style="font-size:24px">
                  <i class="mdi {{item.icon}}"></i>
                </div>

                <div style="flex:1">

                  <div style="display:flex;align-items:center;gap:8px">
                    <strong>{{item.title}}</strong>

                    <span ng-if="item.badge" class="badge bg-{{item.badge.color}}" style="border-radius:50px;text-transform:uppercase;">
                      {{item.badge.label}}
                    </span>
                  </div>

                  <small class="text-muted d-block" style="margin-top:4px">
                    {{item.description}}
                  </small>

                </div>
                <i class="mdi mdi-chevron-right"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`,
    link: function (scope, element) {

      var modal = element.find('.modal');

      scope.$watch('visible', function (value) {

        if (value) {
          $timeout(function () {
            modal.modal('show');
          });
        } else {
          modal.modal('hide');
        }

      });

      modal.on('hidden.bs.modal', function () {
        scope.$apply(function () {
          scope.visible = false;
        });
      });

      scope.select = function (item) {

        if (scope.onSelect) {
          scope.onSelect({ item: item });
        }

        scope.visible = false;
      };

      scope.close = function () {
        scope.visible = false;
      };

    }
  };
});

app.directive('stopPropagation', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            // Listen for the specified events (default is click and focus)
            element.on(attrs.stopPropagation || 'click focus', function (event) {
                event.stopPropagation(); // Stop the event from propagating
            });
        }
    };
});

app.directive('radioGroup', function () {
    return {
        restrict: 'E',
        scope: {
            inputs: '=',
            multiple: '=?', // Optional multiple selection, defaults to false,
            change: '&?', // Optional change event handler
        },
        require: 'ngModel',
        template: `
            <div class="radio-group">
                <label class="form-label text-muted d-block mb-0">
                    {{inputs.label}}
                    <tooltip-icon ng-if="inputs.tooltip" tooltip="[[inputs.tooltip]]"></tooltip-icon>
                </label>
                <div class="btn-group" role="group">
                    <button
                        type="button"
                        class="btn btn-xs btn-outline-primary"
                        ng-class="{ 'active': isSelected(value.value) && !multiple }"
                        ng-repeat="value in inputs.values"
                        ng-click="toggleValue(value.value, $event)">
                        <span ng-if="multiple && isSelected(value.value)" class="mdi mdi-checkbox-marked-circle"></span>
                        <span ng-if="multiple && !isSelected(value.value)" class="mdi mdi-checkbox-blank-circle-outline"></span>
                        {{value.label}}
                    </button>
                </div>
            </div>
        `,
        link: function (scope, element, attrs, ngModelCtrl) {
            // Default multiple to false if not specified
            scope.multiple = scope.multiple || false;

            // Initialize the model value
            ngModelCtrl.$render = function () {
                scope.ngModel = ngModelCtrl.$viewValue;
            };

            scope.isSelected = function (value) {
                if (scope.multiple) {
                    return Array.isArray(scope.ngModel) && scope.ngModel.includes(value);
                }
                return scope.ngModel === value;
            };

            scope.toggleValue = function (value, event) {
                let oldValue = angular.copy(scope.ngModel); // Capture the old model value

                if (scope.multiple) {
                    let selectedValues = Array.isArray(scope.ngModel) ? [...scope.ngModel] : [];
                    let index = selectedValues.indexOf(value);
                    if (index > -1) {
                        selectedValues.splice(index, 1); // Deselect
                    } else {
                        selectedValues.push(value); // Select
                    }
                    ngModelCtrl.$setViewValue(selectedValues);
                } else {
                    ngModelCtrl.$setViewValue(value);
                }
                ngModelCtrl.$render();

                if (scope.change && !angular.equals(oldValue, ngModelCtrl.$viewValue)) {
                    scope.change({ newValue: ngModelCtrl.$viewValue, oldValue: oldValue });
                }

                if (event && event.currentTarget) {
                    event.currentTarget.blur();
                }
            };
        }
    };
});

app.directive('setAttrs', function () {
    return {
        restrict: 'A',
        scope: false,
        link: function (scope, element, attrs) {
            scope.$watch(attrs.setAttrs, function (newAttrs) {
                // Remove all previous dynamic attributes
                angular.forEach(element[0].attributes, function (attr) {
                    if (newAttrs && newAttrs.hasOwnProperty(attr.name)) {
                        element[0].removeAttribute(attr.name);
                    }
                });

                if (newAttrs) {
                    // Set new attributes
                    angular.forEach(newAttrs, function (value, key) {
                        element[0].setAttribute(key, value);
                    });
                }
            }, true);
        }
    };
});

app.directive('carouselSlide', function () {
    return {
        restrict: 'E',
        scope: {
            images: '='
        },
        template: `
            <div class="carousel-container" ng-if="images && images.length > 0">
                <img ng-src="[[getCurrentImage()]]" class="carousel-image">

                <div class="carousel-controls d-flex gap-1 mt-1" ng-if="images.length > 1">
                    <button class="btn btn-primary btn-xs w-100 carousel-btn" ng-disabled="currentIndex === 0" ng-click="prev()">
                        <i class="mdi mdi-chevron-left"></i>
                    </button>

                    <button class="btn btn-primary btn-xs w-100 carousel-btn" ng-disabled="currentIndex === images.length - 1" ng-click="next()">
                        <i class="mdi mdi-chevron-right"></i>
                    </button>
                </div>
            </div>
        `,
        controller: function ($scope) {
            $scope.currentIndex = 0;

            $scope.prev = function () {
                if ($scope.currentIndex > 0) {
                    $scope.currentIndex--;
                }
            };

            $scope.next = function () {
                if ($scope.currentIndex < $scope.images.length - 1) {
                    $scope.currentIndex++;
                }
            };

            $scope.getCurrentImage = function () {
                return $scope.images[$scope.currentIndex];
            }
        },
        link: function (scope, element, attrs) {
            if (!Array.isArray(scope.images)) {
                scope.images = [];
            }
        }
    };
});


app.directive('help', function ($rootScope) {
    return {
        restrict: 'E',
        scope: {
            id: '@?',
            group: '@?',
            ids: '@?',
        },
        template: `
        <span role="button" class="ms-2 text-primary" style="cursor: pointer!important;z-index:10000000"
              ng-click="triggerHelp()">
          <i class="bi bi-question-circle"></i>
        </span>
      `,
        link: function (scope) {
            scope.triggerHelp = function () {
                var data = {};
                if (scope.id) data.id = scope.id;
                if (scope.group) data.group = scope.group;
                if (scope.ids) data.ids = scope.ids.split(',').map(function (id) { return id.trim(); });
                $rootScope.$broadcast('help.show', data);
            };
        }
    };
});

app.directive('contentRender', function ($timeout, api) {
    return {
        restrict: 'E',
        scope: {
            content: '=?',
            contentId: '=',
            onActivate: '=?',
        },
        link: function ($scope, element, attrs) {
            $scope.activeTabs = {}
            $scope.activeTab = null
            $scope.activeCard = null
            $scope.activeCardContent = null
            $scope.breadcrumbs = []

            $scope.activateTab = function (section, tab) {
                $scope.activeTabs[section.id] = tab.id
                $scope.activeTab = tab
            }

            $scope.init = function () {
                function setTabs(content) {
                    for (let section of content) {
                        if (section.type == 'tabs') {
                            $scope.activateTab(section, section.sections[0])
                            setTabs(section.sections)
                        }
                    }
                }
                setTabs($scope.content)
                $timeout(angular.noop)
            }

            $scope.$watch('contentId', function (newVal) {
                if (newVal) {
                    $scope.activeTabs = {}
                    $scope.activeTab = null
                }
                if (!newVal) {
                    return
                }
                $scope.loading = true
                api.getHelpContent(newVal).then(function (response) {
                    $scope.content = response.data
                })
                    .catch(function () {
                        // TASK - No handling
                    })
                    .finally(function () {
                        $scope.loading = false
                        $timeout(angular.noop)
                    })
            })

            $scope.$watch('content', function (newVal) {
                if (!newVal || newVal.length == 0 || newVal.filter(item => item).length == 0) {
                    return
                }
                $scope.init()
            })

            $scope.getActiveCardContent = function () {
                if (!$scope.activeCard) {
                    return
                }
                $scope.loading = true
                api.getHelpContent($scope.activeCard.link).then(function (response) {
                    $scope.activeCardContent = response.data
                })
                    .catch(function () {
                        // TASK - No handling
                    })
                    .finally(function () {
                        $scope.loading = false
                        $timeout(angular.noop)
                    })
            }

            $scope.activateCard = function (card) {
                if (card == null) {
                    $scope.breadcrumbs = []
                    $scope.activeCard = null
                    $scope.activeCardContent = null
                    return
                }
                // Check if card is already on breadcrumbs if so remove all after it
                let index = $scope.breadcrumbs.indexOf(card)
                if (index != -1) {
                    $scope.breadcrumbs = $scope.breadcrumbs.slice(0, index + 1)
                } else {
                    $scope.breadcrumbs.push(card)
                }
                $scope.activeCard = card
                $scope.getActiveCardContent()
            }

            if (!$scope.onActivate) {
                $scope.onActivate = function (card) {
                    $scope.activateCard(card)
                }
            }
        },
        template: `
            <div ng-if="loading" class="text-center">
                <i class="mdi mdi-loading mdi-spin" style="font-size: 40px;margin: 30px"></i>
            </div>
            <!-- breadcrumbs -->
            <div ng-if="breadcrumbs.length > 0" class="mb-2">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <!-- Add home help -->
                        <li class="breadcrumb item" ng-click="activateCard(null)" style="cursor: pointer">
                            <i class="mdi mdi-home"></i>
                        </li>
                        <li class="breadcrumb item" ng-repeat="item in breadcrumbs">
                            <a href="javascript:void(0)" ng-click="activateCard(item)">{{item.title}}</a>
                        </li>
                    </ol>
                </nav>
            </div>
            <div ng-repeat="section in content" class="mb-2" ng-show="!activeCard">
                <div ng-if="section.type == 'p' || section.content.length > 0">
                    <div class="mb-1" ng-repeat="element in section.content track by $index">
                        <p style="margin:0px 0px 3px 0px" ng-bind-html="element.content | trusted" ng-if="element.type == 'text'"></p>
                        <img ng-src="{{element.src}}" ng-if="element.type == 'image'" style="max-width: 100%">
                        <video ng-src="{{element.src}}" ng-if="element.type == 'video'" muted autoplay style="max-height: 500px" controls></video>
                    </div>
                </div>
                <div ng-if="section.type == 'tabs'">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" ng-repeat="tab in section.sections">
                            <a
                                class="nav-link" ng-class="{active: activeTabs[section.id] == tab.id}"
                                ng-click="activateTab(section, tab)" href="javascript:void(0)">
                                {{tab.title}}
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content mt-1">
                        <div class="tab-pane active">
                            <content-render content="[activeTab]"></content-render>
                        </div>
                    </div>
                </div>
                <div ng-if="section.type == 'cards'">
                    <div class="row">
                        <div class="col-md-4" ng-repeat="card in section.sections">
                            <div class="card mb-2" ng-click="onActivate(card);">
                                <div class="card-body" style="padding: 12px;min-height: 90px; cursor: pointer; user-select: none; text-align: center">
                                    <!-- add icon mdi -->
                                    <i ng-if="card.icon" class="mdi mdi-{{card.icon}}" style="font-size: 30px; color: #744ffe"></i>
                                    <h5 class="card-title mb-1">{{card.title}}</h5>
                                    <p class="card-text" ng-bind-html="card.content"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div ng-if="section.type == 'accordion'">
                    <div class="accordion">
                        <div class="accordion-item" ng-repeat="tab in section.sections">
                            <h2 class="accordion-header" id="headingOne">
                                <button class="accordion-button" type="button"
                                    ng-click="activateTab(section, tab)" ng-class="{collapsed: activeTabs[section.id] != tab.id}">
                                    {{tab.title}}
                                </button>
                            </h2>
                            <div class="accordion-collapse" ng-class="{show: activeTabs[section.id] == tab.id, 'd-none': activeTabs[section.id] != tab.id}">
                                <div class="accordion-body">
                                    <content-render content="[activeTab]"></content-render>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div ng-if="section.type == 'container'">
                    <content-render content="section.sections"></content-render>
                </div>
            </div>
            <content-render ng-if="activeCardContent" content="activeCardContent" on-activate="onActivate"></content-render>
        `
    }
})

// Create a content-render-modal, it accepts content-id and opens a modal with the content-render. It also has a show parameter to open the modal. also whenever the modal hides it resets the content and the param
app.directive('contentRenderModal', function () {
    return {
        restrict: 'E',
        scope: {
            contentId: '=',
            title: '=',
            show: '=?',
        },
        link: function ($scope, element, attrs) {
            $scope.gettext = gettext
            $scope.$watch('show', function (newVal) {
                if (typeof newVal == 'boolean' && element && element.find('.modal') && element.find('.modal').modal) {
                    element.find('.modal').modal(newVal ? 'show' : 'hide')
                    let modal = element.find('.modal')
                    modal.css('z-index', 100000000)
                }
            })

            if (element) {
                element.find('.modal').on('hidden.bs.modal', function () {
                    $scope.show = false
                    $scope.contentId = null
                })
            }
        },
        template: `
            <div class="modal modal-lg" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{title || gettext('label.help_modal')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <content-render content-id="contentId"></content-render>
                        </div>
                    </div>
                </div>
            </div>
        `
    }
})


app.directive('buttonSplit', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            main: '=',
            label: '@?',
            items: '=',
            dropdownPosition: '@',
            btnSize: '@?',
            btnClass: '@?',
            disabled: '=?',
            primary: '=?',
        },
        template: `
            <!-- Wrapper: behaves as split or single button -->
            <div ng-class="{'btn-group': main && main.action, 'dropdown': !main || !main.action}">

                <!-- Split mode: main + toggle -->
                <button ng-if="main && main.action" type="button" class="btn"
                    ng-class="['btn-' + btnSize, btnClass, primary ? 'btn-primary' : 'btn-outline-primary']"
                    ng-click="!disabled && doAction(main, $event)"
                    ng-disabled="disabled">
                    <i ng-if="main.icon" class="mdi mdi-{{main.icon}}"></i>
                    {{main.label}}
                </button>

                <button ng-if="main && main.action" type="button"
                    class="btn dropdown-toggle dropdown-toggle-split"
                    data-bs-display="static"
                    ng-class="['btn-' + btnSize, btnClass, {'show': showDropdown}, primary ? 'btn-primary' : 'btn-outline-primary']"
                    ng-click="!disabled && toggleDropdown($event)"
                    ng-disabled="disabled">
                    <span class="visually-hidden">Toggle Dropdown</span>
                </button>

                <!-- Single button (no main.action): acts as label + dropdown toggle -->
                <button ng-if="!main || !main.action" type="button"
                    class="btn"
                    data-bs-display="static"
                    ng-class="['btn-' + btnSize, btnClass, {'show': showDropdown}, primary ? 'btn-primary' : 'btn-outline-primary']"
                    ng-click="!disabled && toggleDropdown($event)"
                    ng-disabled="disabled">
                    <i ng-if="main && main.icon" class="mdi mdi-{{main.icon}}"></i>
                    {{main.label}}
                </button>

                <!-- Dropdown menu -->
                <ul class="dropdown-menu"
                    ng-class="{'show': showDropdown}"
                    style="{{dropdownPosition === 'top' ? 'bottom: 100%;' : 'top: 100%;'}}">
                    <li ng-repeat="item in items" ng-if="isVisible(item)">
                        <a class="dropdown-item" href="javascript:void(0)"
                            ng-click="!disabled && doAction(item, $event)"
                            ng-class="{'disabled': disabled}">
                            <i ng-if="item.icon" class="{{item.icon}}" style="margin-right: 5px"></i>
                            {{item.label}}
                        </a>
                    </li>
                </ul>

            </div>
        `,
        link: function ($scope, element, attrs) {
            $scope.btnSize = attrs.btnSize || 'sm';
            $scope.showDropdown = false;

            $scope.toggleDropdown = function (event) {
                if ($scope.disabled) return;  // Prevent action when disabled
                event.stopPropagation();
                $scope.showDropdown = !$scope.showDropdown;
            }

            $scope.isVisible = function (item) {
                return typeof item.visible === 'undefined' || item.visible;
            }

            $scope.doAction = function (item, $event) {
                if ($event) {
                    $event.stopPropagation();
                }
                if ($scope.disabled) return;  // Prevent action when disabled
                $scope.showDropdown = false;
                if (item.args) {
                    item.action(...item.args);
                } else {
                    item.action();
                }
            }

            document.addEventListener('click', function (event) {
                if ($scope.showDropdown && !element[0].contains(event.target)) {
                    $timeout(() => {
                        $scope.showDropdown = false;
                    })
                }
            });
        }
    };
});

app.directive('draggable', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.attr('draggable', true);

            element.bind('dragstart', function (event) {
                event = event.originalEvent || event;
                if (!event.dataTransfer) {
                    event.dataTransfer = new DataTransfer()
                }

                event.dataTransfer.setData('text', attrs.itemid);
            });
        }
    };
})

app.directive('checkbox', function () {
    return {
        restrict: 'E',
        scope: {
            ngModel: '=',
            trueValue: '@?',
            falseValue: '@?',
            trueLabel: '@',
            falseLabel: '@?',
            tooltipText: '@',
            onChange: '&?'
        },
        template: `
            <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" ng-model="checked" ng-change="handleChange()">
                <label class="form-check-label" for="flexSwitchCheckDefault">{{ label }}</label>
                <tooltip-icon ng-if="tooltipText" class="ms-1" tooltip="{{ tooltipText }}"></tooltip-icon>
            </div>
        `,
        link: function (scope, element, attrs) {
            // Fallback to boolean true/false if no values are provided
            if (typeof scope.trueValue === 'undefined') {
                scope.trueValue = true;
            }
            if (typeof scope.falseValue === 'undefined') {
                scope.falseValue = false;
            }

            scope.updateModel = function () {
                scope.ngModel = scope.checked ? scope.trueValue : scope.falseValue;
                scope.label = scope.checked ? scope.trueLabel : (scope.falseLabel || scope.trueLabel);
            };

            scope.handleChange = function () {
                scope.updateModel();
                if (scope.onChange) {
                    scope.onChange({ value: scope.ngModel });
                }
            };

            scope.$watch('ngModel', function (newVal) {
                scope.checked = newVal == scope.trueValue;
                scope.label = scope.checked ? scope.trueLabel : (scope.falseLabel || scope.trueLabel);
            });
        }
    };
});

app.directive('droppable', function () {
    return {
        restrict: 'A',
        scope: {
            droppable: '=',
            drop: '&'
        },
        link: function (scope, element, attrs) {
            element.bind('dragover', function (event) {
                event.preventDefault();
            });

            element.bind('drop', function (event) {
                event.preventDefault();
                event = event.originalEvent || event;
                var data = event.dataTransfer.getData('text');
                scope.$apply(function () {
                    scope.drop()(data, scope.droppable);
                });
            });
        }
    };
});

app.directive('editable', function ($timeout) {
    return {
        restrict: 'A', // Attribute only
        scope: {
            contentId: '@', // Bind the id attribute from the parent scope
            change: '=' // Bind the callback function from the parent scope
        },
        link: function (scope, element, attrs) {
            var debounce;

            element.attr('contenteditable', attrs.contenteditable || 'true');

            function triggerChange() {
                if (debounce) {
                    $timeout.cancel(debounce);
                }
                debounce = $timeout(function () {
                    var html = element.html();
                    scope.change({ content: html, id: scope.contentId });
                }, 150);
            }

            element.on('input keyup paste', function () {
                scope.$apply(triggerChange);
            });

            // Optional: Clean up the event listener and the timeout when the element is destroyed
            scope.$on('$destroy', function () {
                element.off('input keyup paste');
                if (debounce) {
                    $timeout.cancel(debounce);
                }
            });
        }
    };
});

// Filter elipsis
app.filter('ellipsis', function () {
    return function (input, maxLength) {
        if (!input) return '';
        maxLength = parseInt(maxLength) || 100;
        if (input.length > maxLength) {
            return input.substring(0, maxLength) + '...';
        }
        return input;
    };
});

app.directive('defaultCheckbox', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            function isModelInvalid() {
                return ngModelCtrl.$modelValue === undefined || typeof ngModelCtrl.$modelValue === 'undefined' || isNaN(ngModelCtrl.$modelValue)
            }
            // Listen for changes to the model value
            element.on('change', function () {
                $timeout(function () {
                    if (isModelInvalid()) {
                        ngModelCtrl.$setViewValue(true)
                        ngModelCtrl.$setViewValue(false);
                        ngModelCtrl.$render();
                        return
                    }
                    ngModelCtrl.$setViewValue(element.prop('checked'));
                    ngModelCtrl.$render();
                })
            });

            // Watch the ngModel value and update the element's checked state
            scope.$watch(function () {
                return ngModelCtrl.$modelValue;
            }, function (newVal) {
                if (isModelInvalid()) {
                    element.prop('checked', true);
                    return
                }
                element.prop('checked', !!newVal);
            });
        }
    };
});

// Define the module
app.directive('mediaPicker', function () {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            onSelect: '=',
        },
        controller: 'MediaController',
        templateUrl: 'media-picker-template.html'
    };
});

app.directive('onboarding', function () {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            onChange: '=',
            steps: '=?'
        },
        controller: 'OnboardingController',
        templateUrl: 'onboarding-template.html'
    };
});

app
    .directive('pxEdit', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                // Function to parse the value from the model to the view
                ngModelController.$parsers.push(function (value) {
                    return value + 'px';
                });

                // Function to format the value from the view to the model
                ngModelController.$formatters.push(function (value) {
                    return Math.round(parseFloat(value) * 10) / 10;
                });

                // Watch for changes on the element to update the model with 'px'
                element.on('blur keyup change', function () {
                    var viewValue = element.val();
                    // Only update when the view value is a valid number
                    if (!isNaN(viewValue)) {
                        ngModelController.$setViewValue(viewValue);
                        ngModelController.$render();
                    }
                });
            }
        };
    });

app.directive('autocomplete', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            items: '=',
            selected: '=',
            empty: '=',
            allowCustom: '=',
            change: '&',
            size: '@',
            placeholder: '@'
        },
        template: `
           <div style="position: relative;">
                <input type="text" class="form-control form-control-{{size || 'md'}}" ng-model="selectedItem" ng-change="filterItems()" placeholder="{{placeholder || labelSearch}}" ng-blur="onBlur()" ng-focus="startAutocomplete()" ng-model-options="{ debounce: 150 }">
                <i ng-if="empty && selectedItem" class="mdi mdi-close-circle" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;" ng-click="clearSelection()"></i>
                <ul class="dropdown-menu" style="display:block;" ng-show="filteredItems.length">
                    <li ng-repeat="item in filteredItems" ng-click="selectItem(item, $event)" class="dropdown-item" style="cursor: pointer">
                        {{getLabel(item)}}
                    </li>
                </ul>
            </div>
        `,
        link: function ($scope) {
            $scope.keySearch = 'label';
            $scope.labelSearch = gettext('label.type_search');
            const valueKey = 'value';

            $scope.fillInitialValue = function (value) {
                if (!value) {
                    $scope.selectedItem = null;
                    return;
                }
                if (!$scope.items || !$scope.items.length) {
                    return;
                }
                let items = $scope.items.filter(item => item[valueKey] == value);
                if (items.length > 0) {
                    $scope.selectedItem = items[0][$scope.keySearch];
                }
            };

            $scope.clearSelection = function () {
                $scope.selectedItem = '';
                $scope.selected = null;
                $scope.filteredItems = [];
                $timeout(function() {
                    $scope.change();
                })
            };

            $scope.$watch('selected', function (newVal) {
                $scope.fillInitialValue(newVal);
            });
            $scope.$watch('items', function (newVal) {
                if ($scope.selected) {
                    $scope.fillInitialValue($scope.selected);
                }
            });

            $scope.startAutocomplete = function () {
                $scope.selectedItem = '';
                if ($scope.items && $scope.items.length) {
                    $scope.filteredItems = $scope.items.slice(0, 20);
                }
            };
            $scope.getLabel = function (item) {
                return item[$scope.keySearch];
            };

            function normalize(str) {
                return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            }

            $scope.filterItems = function () {
                if (!$scope.items || !$scope.items.length) return;

                function normalize(str) {
                    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                }

                // TODO - improve this
                const stopWords = new Set(['de', 'da', 'do', 'em', 'para', 'com', 'e', 'a', 'o', 'as', 'os']);
                const neutralWords = new Set([
                    'empresa', 'loja'
                ]);

                const allSearchWords = normalize($scope.selectedItem || '')
                    .split(/\s+/)
                    .filter(word => word && !stopWords.has(word));

                if (!allSearchWords.length) {
                    $scope.filteredItems = [];
                    return;
                }

                const scoredItems = $scope.items
                    .map(item => {
                        const itemValue = item[$scope.keySearch] || '';
                        const normalizedMain = normalize(itemValue);
                        const normalizedKeywords = Array.isArray(item.keywords)
                            ? item.keywords.map(k => normalize(k))
                            : [];

                        // Filtrar: se QUALQUER palavra da busca estiver no campo principal ou keywords
                        const matchesAny = allSearchWords.some(word =>
                            normalizedMain.includes(word) ||
                            normalizedKeywords.some(k => k.includes(word))
                        );

                        if (!matchesAny) return null;

                        // Ranking: SOMENTE com palavras que NÃO são neutras
                        let score = 0;
                        for (let word of allSearchWords) {
                            if (neutralWords.has(word)) continue; // ignora na pontuação

                            if (normalizedMain.includes(word)) score += 2;
                            if (normalizedKeywords.some(k => k.includes(word))) score += 1;
                        }

                        return { item, score };
                    })
                    .filter(entry => entry) // inclui todos os que passaram no filtro
                    .sort((a, b) => b.score - a.score); // ordena por score

                $scope.filteredItems = scoredItems.map(entry => entry.item);
            };

            let ignoreBlur = false
            let timerBlur = null;
            $scope.onBlur = function () {
                if (timerBlur) {
                    $timeout.cancel(timerBlur);
                }
                timerBlur = $timeout(function () {
                    if (ignoreBlur) {
                        ignoreBlur = false
                        return
                    }
                    let noItemsFound = !$scope.items || !$scope.items.length || $scope.items.filter(item => item[$scope.keySearch] == $scope.selectedItem).length == 0;
                    if (($scope.selectedItem && noItemsFound) || !$scope.selectedItem) {
                        if ($scope.allowCustom && $scope.selectedItem) {
                            $scope.selected = $scope.selectedItem;
                        } else {
                            $scope.fillInitialValue($scope.selected);
                        }
                    }
                    $scope.filteredItems = [];
                    if ($scope.selected) {
                        $scope.change();
                    }
                }, 300);
            };

            $scope.selectItem = function (item, $event) {
                ignoreBlur = true
                if ($event) {
                    $event.stopPropagation();
                    $event.preventDefault();
                }
                $scope.selectedItem = item[$scope.keySearch];
                $scope.filteredItems = [];
                $scope.selected = item[valueKey];
                $timeout(angular.noop);
                $scope.change();
            };

            $scope.filterItems();
        }
    };
});

app.directive('tooltipIcon', ['$timeout', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            tooltip: '@'
        },
        template: `
            <div class="tooltip-container" ng-click="toggleTooltip()" ng-class="{'show-tooltip': tooltipVisible}">
                <i class="mdi mdi-information"></i>
                <div class="tooltip-content">{{tooltip}}</div>
            </div>
        `,
        link: function (scope) {
            let timer = null
            scope.tooltipVisible = false;
            scope.toggleTooltip = function () {
                if (timer) {
                    $timeout.cancel(timer);
                }
                if (scope.tooltipVisible) {
                    if (timer) {
                        $timeout.cancel(timer);
                    }
                    scope.tooltipVisible = false;
                } else {
                    scope.tooltipVisible = true;

                    const minDuration = 4000
                    // Calculate the duration based on the tooltip number of words and the average reading speed
                    let words = scope.tooltip.split(' ').length
                    // Average reading speed is 200 words per minute
                    let duration = Math.max(minDuration, words / 200 * 60 * 1000)
                    timer = $timeout(function () {
                        scope.tooltipVisible = false;
                    }, duration);
                }
            };
        }
    };
}]);

app.directive('colorpickeritem', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            pallete: '=',
            colors: '=',
            editing: '=',
            change: '&',
            remove: '&',
            cancelAdd: '&',
            onEdit: '&',
            onEditEnd: '&',
            apply: '&'
        },
        template: `
            <div ng-if="!editing" class="picker-preview v-align d-flex flex-wrap">
                <div ng-repeat="(key, value) in pallete track by $index"
                    ng-show="key == 'main' || key == 'text' || key == 'highlight'"
                    style="background-color: {{value}};"
                    class="picker-item-color"
                    ng-click="toggleEditing()">
                </div>
                <!-- add edit, use, and remove button -->
                <a href="javascript:void(0)"  ng-click="apply()" class="me-2">
                    <i class="mdi mdi-format-color-fill"></i>
                    {{gettext('label.apply_pallete')}}
                </a>
                <a href="javascript:void(0)"  ng-click="toggleEditing()" class="me-2">
                    <i class="mdi mdi-pencil"></i>
                    {{gettext('label.generic_edit')}}
                </a>
                <a href="javascript:void(0)" ng-click="remove()" class="me-2">
                    <i class="mdi mdi-delete"></i>
                    {{gettext('label.generic_remove')}}
                </a>
            </div>
            <div ng-if="editing" class="picker-edit">
                <div class="row">
                    <label class="col-12 col-md-3 col-form-label">{{gettext('label.main_color')}}</label>
                    <div class="col-12 col-md-9 v-align">
                        <input id="main-input-color" type="color" ng-model="tempPallete.main" ng-model-options="{ debounce: 100 }">
                        <a href="javascript:void(0)" ng-click="showColor('main')" class="picker-show-color-btn">
                            [[gettext('label.click_to_edit_color')]]
                        </a>
                        <div>
                            <div ng-repeat="color in colors track by $index"
                                ng-click="selectColor(color.value, 'main')"
                                style="background-color: {{color.value}};"
                                class="picker-item-color">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-12 col-md-3 col-form-label">{{gettext('label.text_color')}}</label>
                    <div class="col-12 col-md-9 v-align">
                        <input id="text-input-color" type="color" ng-model="tempPallete.text" ng-model-options="{ debounce: 100 }">
                        <a href="javascript:void(0)" ng-click="showColor('text')" class="picker-show-color-btn">
                            [[gettext('label.click_to_edit_color')]]
                        </a>
                        <div>
                            <div ng-repeat="color in colors track by $index"
                                ng-click="selectColor(color.value, 'text')"
                                style="background-color: {{color.value}};"
                                class="picker-item-color">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label class="col-12 col-md-3 col-form-label">{{gettext('label.accent_color')}}</label>
                    <div class="col-12 col-md-9 v-align">
                        <input id="highlight-input-color" type="color" ng-model="tempPallete.highlight" ng-model-options="{ debounce: 100 }">
                        <a href="javascript:void(0)" ng-click="showColor('highlight')" class="picker-show-color-btn">
                            [[gettext('label.click_to_edit_color')]]
                        </a>
                        <div>
                            <div ng-repeat="color in colors track by $index"
                                ng-click="selectColor(color.value, 'highlight')"
                                style="background-color: {{color.value}};"
                                class="picker-item-color">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-wrap mt-2">
                    <a href="javascript:void(0)" ng-click="save()" class="me-2 btn btn-outline-primary btn-xs">
                        <i class="mdi mdi-content-save"></i>
                        {{gettext('label.generic_save')}}
                    </a>
                    <a href="javascript:void(0)" ng-click="cancel()" class="me-2 btn btn-outline-secondary btn-xs">
                        <i class="mdi mdi-close"></i>
                        {{gettext('label.generic_cancel')}}
                    </a>
                </div>
            </div>
        `,
        link: function (scope) {
            scope.gettext = gettext
            // Temporary palette to store editing changes
            scope.tempPallete = angular.copy(scope.pallete);

            // Toggles editing mode
            scope.toggleEditing = function () {
                scope.editing = true;
                scope.tempPallete = angular.copy(scope.pallete);
                scope.onEdit()
            };

            // Save changes
            scope.save = function () {
                delete scope.tempPallete.editing
                delete scope.tempPallete.isNew
                angular.copy(scope.tempPallete, scope.pallete);
                scope.editing = false;
                scope.change();
                scope.onEditEnd()
            };

            // Cancel changes
            scope.cancel = function () {
                if (scope.tempPallete.isNew) {
                    scope.cancelAdd();
                }
                scope.tempPallete = angular.copy(scope.pallete);
                scope.editing = false;
                scope.onEditEnd()
            };

            // Select a color from the palette
            scope.selectColor = function (color, key) {
                scope.tempPallete[key] = color;
            };

            // Show color editing (stubbed for future expansion)
            scope.showColor = function (key) {
            };
        }
    };
});

app.directive('fontsize', function ($rootScope) {
    return {
        restrict: 'E',
        scope: {
            settings: '=',
            change: '='
        },
        link: function ($scope) {
            $scope.gettext = gettext
            $scope.formatRemToPX = $rootScope.formatRemToPX
        },
        template: `
            <div class="alert alert-info">
                {{gettext('label.font_size_info')}}
            </div>
            <div class="row">
                <div class="fs-3">
                    {{gettext('label.title_font_header')}}
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_max_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.titleSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_max_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('titleSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="4" step="0.1" ng-model="settings.titleSize">
                    </div>
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_min_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.titleMinSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_min_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('titleMinSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="4" step="0.1" ng-model="settings.titleMinSize">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="fs-3">
                    {{gettext('label.description_font_header')}}
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_max_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.descriptionSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_max_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('descriptionSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="2" step="0.1" ng-model="settings.descriptionSize">
                    </div>
                </div>
                <div class="col-md-6 col-xs-12">
                    <div class="input-group mb-3">
                        <!-- Range for font size-->
                        <label class="form-label w-100">
                            {{gettext('label.text_min_size')}}
                            <span style="float:right;font-weight: bold;">
                                [[formatRemToPX(settings.descriptionMinSize)]]
                            </span>
                            <tooltip-icon tooltip="{{gettext('label.text_min_size_tooltip')}}"></tooltip-icon>
                        </label>
                        <input ng-change="change('descriptionMinSize')" type="range" ng-model-options="{ debounce: 100 }" class="form-range" min="0" max="2" step="0.1" ng-model="settings.descriptionMinSize">
                        <p>
                        </p>
                    </div>
                </div>
            </div>
            `
    };
})

app.directive('colorpicker', function ($timeout) {
    return {
        restrict: 'E',
        scope: {
            pallete: '=',
            colors: '=',
            palletes: '=',
            change: '&',
        },
        template: `
            <div class="row mb-5">
                <div class="col-sm-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <button class="nav-link" type="button" ng-class="{active: state.tab == 'theme'}" ng-click="state.tab = 'theme'">{{gettext('label.colors_theme')}}</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" type="button" ng-class="{active: state.tab == 'custom'}" ng-click="state.tab = 'custom'">{{gettext('label.colors_custom')}}</button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" type="button" ng-class="{active: state.tab == 'picker'}" ng-click="state.tab = 'picker'">{{gettext('label.colors_picker')}}</button>
                        </li>
                    </ul>
                    <div class="picker-wrapper">
                        <div ng-if="state.tab == 'theme'">
                            <div style="display: flex; flex-wrap: wrap; justify-content: center;">
                                <div ng-repeat="pallete in basePalletes" ng-style="{'background-color': pallete.main, 'color': pallete.text}" class="color-selection" ng-click="changePallete(pallete)">
                                Abc
                                </div>
                            </div>
                            <div ng-show="selectedPallete" style="display: flex; flex-wrap: wrap; justify-content: center;border-top: 1px solid #ddd">
                                <div ng-click="selectedPallete=null" class="color-selection">
                                    <i style="font-size:20px" class="mdi mdi-close"></i>
                                </div>
                                <div ng-repeat="pallete in selectedPallete.palletes" ng-style="{'background-color': pallete.main, 'color': pallete.text}" class="color-selection" ng-click="changePallete(pallete)">
                                    Abc
                                </div>
                            </div>
                        </div>
                        <div ng-if="state.tab == 'picker'">

                            <div>
                                <label for="logoUserInput" class="file-input-button btn btn-outline-primary">
                                    <i class="mdi mdi-cloud-upload" style="font-size: 16px"></i>
                                    [[gettext('button.upload_file_detect_color')]]
                                </label>
                                <input class="logoUserInput" type="file" accept="image/*" id="logoUserInput" style="display: none;">
                            </div>

                            <img id="logoUserImagePreview" class="logoUserImagePreview mt-2">
                        </div>
                        <!-- Main -->
                        <div class="row">
                            <label class="col-12 col-md-3 col-form-label v-align">{{gettext('label.main_color')}}</label>
                            <div class="col-12 col-md-9 v-align">
                                <input id="main-input-color" type="color" ng-model="pallete.main" ng-model-options="{ debounce: 100 }"  ng-change="change()">
                                <a href="javascript:void(0)" ng-click="showColor('main')" class="picker-show-color-btn">
                                    [[gettext('label.click_to_edit_color')]]
                                </a>
                                <a ng-if="state.tab != 'picker' && !listColorsAvailable" href="javascript:void(0)" ng-click="showListColors()" class="picker-show-color-btn ms-2">
                                    [[gettext('label.click_to_select_color')]]
                                </a>
                                <div ng-if="state.tab != 'picker' && listColorsAvailable" class="ms-1 v-align d-flex flex-wrap">
                                    <div ng-repeat="color in colors track by $index"
                                        ng-click="selectColor(color.value, 'main')"
                                        style="background-color: {{color.value}};"
                                        class="picker-item-color">
                                    </div>
                                </div>
                            </div>
                            <div class="picker-colors-wrapper" ng-if="state.tab == 'picker'">
                                <div ng-repeat="color in detectedColors track by $index"
                                    ng-click="selectColor(color, 'main')"
                                    style="background-color: {{color}};"
                                    class="picker-item-color">
                                </div>
                            </div>
                        </div>
                        <!-- Text -->
                        <div class="row">
                            <label class="col-12 col-md-3 col-form-label v-align">{{gettext('label.text_color')}}</label>
                            <div class="col-12 col-md-9 v-align">
                                <input id="text-input-color" type="color" ng-model="pallete.text" ng-model-options="{ debounce: 100 }"  ng-change="change()">
                                <a href="javascript:void(0)" ng-click="showColor('text')" class="picker-show-color-btn">
                                    [[gettext('label.click_to_edit_color')]]
                                </a>
                                <a ng-if="state.tab != 'picker' && !listColorsAvailable" href="javascript:void(0)" ng-click="showListColors()" class="picker-show-color-btn ms-2">
                                    [[gettext('label.click_to_select_color')]]
                                </a>
                                <div ng-if="state.tab != 'picker' && listColorsAvailable" class="ms-1 v-align d-flex flex-wrap">
                                    <div ng-repeat="color in colors track by $index"
                                        ng-click="selectColor(color.value, 'text')"
                                        style="background-color: {{color.value}};"
                                        class="picker-item-color">
                                    </div>
                                </div>
                            </div>
                            <div class="picker-colors-wrapper" ng-if="state.tab == 'picker'">
                                <div ng-repeat="color in detectedColors track by $index"
                                    ng-click="selectColor(color, 'text')"
                                    style="background-color: {{color}};"
                                    class="picker-item-color">
                                </div>
                            </div>
                        </div>
                        <!-- Accent -->
                        <div class="row">
                            <label class="col-12 col-md-3 col-form-label v-align">{{gettext('label.accent_color')}}</label>
                            <div class="col-12 col-md-9 v-align">
                                <input id="highlight-input-color" type="color" ng-model="pallete.highlight" ng-model-options="{ debounce: 100 }"  ng-change="change()">
                                <a href="javascript:void(0)" ng-click="showColor('highlight')" class="picker-show-color-btn">
                                    [[gettext('label.click_to_edit_color')]]
                                </a>
                                <a ng-if="state.tab != 'picker' && !listColorsAvailable" href="javascript:void(0)" ng-click="showListColors()" class="picker-show-color-btn ms-2">
                                    [[gettext('label.click_to_select_color')]]
                                </a>
                                <div ng-if="state.tab != 'picker' && listColorsAvailable" class="ms-1 v-align d-flex flex-wrap">
                                    <div ng-repeat="color in colors track by $index"
                                        ng-click="selectColor(color.value, 'highlight')"
                                        style="background-color: {{color.value}};"
                                        class="picker-item-color">
                                    </div>
                                </div>
                            </div>
                            <div class="picker-colors-wrapper" ng-if="state.tab == 'picker'">
                                <div ng-repeat="color in detectedColors track by $index"
                                    ng-click="selectColor(color, 'highlight')"
                                    style="background-color: {{color}};"
                                    class="picker-item-color">
                                </div>
                            </div>
                        </div>
                        <!-- My colors -->
                        <div class="row">
                            <label class="col-12 col-md-4 col-form-label">
                                {{gettext('label.my_colors')}}
                            </label>
                            <div class="col-12 col md-9 v-align d-flex flex-wrap" ng-if="editingColors">
                                <div ng-repeat="color in tempColors track by $index" class="me-3" style="position: relative">
                                    <i class="mdi mdi-close-circle" style="position: absolute; top: -10px; right: -10px; cursor: pointer;" ng-click="tempColors.splice($index, 1)"></i>
                                    <input type="color" ng-model="color.value">
                                </div>
                                <a href="javascript:void(0)" ng-click="addNewColor()" class="me-3">
                                    <i class="mdi mdi-plus"></i> {{gettext('label.generic_add')}}
                                </a>
                                <a href="javascript:void(0)" ng-click="saveEditColors()" class="me-3">
                                    <i class="mdi mdi-content-save"></i> {{gettext('label.generic_save')}}
                                </a>
                                <a href="javascript:void(0)" ng-click="cancelEditColors()" class="me-3">
                                    <i class="mdi mdi-close"></i> {{gettext('label.generic_cancel')}}
                                </a>
                            </div>
                            <div class="col-12 col md-9 v-align" ng-if="!editingColors">
                                <div ng-repeat="color in colors track by $index"
                                    ng-click="editColors()"
                                    style="background-color: {{color.value}};"
                                    class="picker-item-color">
                                </div>
                                <a href="javascript:void(0)" ng-click="editColors()">
                                    <i class="mdi mdi-pencil"></i>
                                    {{gettext('label.generic_edit')}}
                                </a>
                            </div>
                        </div>
                        <!-- My palletes -->
                        <div class="row">
                            <label class="col-12 col-md-4 col-form-label">
                                {{gettext('label.my_palletes')}}
                            </label>
                            <div class="col-12 col">
                                <div ng-repeat="pallete in palletes">
                                    <colorpickeritem
                                        ng-if="currentEditingIndex == $index || currentEditingIndex == null"
                                        pallete="pallete"
                                        colors="colors"
                                        change="change()"
                                        apply="apply($index)"
                                        remove="remove($index)"
                                        cancel-add="cancelAdd($index)"
                                        on-edit="onStartEditing($index)"
                                        on-edit-end="onEndEditing($index)"
                                        editing="pallete.editing">
                                    </colorpickeritem>
                                </div>
                            </div>
                            <a href="javascript:void(0)" ng-click="addNewPallete()" ng-if="currentEditingIndex == null" class="mt-2">
                                <i class="mdi mdi-plus"></i>
                                {{gettext('label.add_new_pallete')}}
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        `,
        link: function ($scope, $element) {
            $scope.gettext = gettext
            $scope.basePalletes = buildPalletes()
            $scope.editingColors = false
            $scope.listColorsAvailable = false
            $scope.currentEditingIndex = null
            $scope.tempColors = []

            $scope.detectedColors = []

            let intervalCheck = setInterval(function () {
                if (!$element.find('.logoUserInput')[0]) {
                    return
                }
                clearInterval(intervalCheck)
                $scope.init()
            }, 100)


            $scope.showListColors = function () {
                $scope.listColorsAvailable = true
            }

            $scope.editColors = function () {
                $scope.tempColors = JSON.parse(JSON.stringify($scope.colors))
                $scope.editingColors = true
            }

            $scope.cancelEditColors = function () {
                $scope.editingColors = false
            }

            $scope.saveEditColors = function () {
                let uniqueColors = []
                $scope.tempColors.forEach(color => {
                    if (!uniqueColors.find(c => c.value == color.value)) {
                        uniqueColors.push(color)
                    }
                })
                $scope.colors = JSON.parse(JSON.stringify(uniqueColors))
                $scope.editingColors = false
                $scope.change()
            }

            $scope.addNewColor = function () {
                $scope.tempColors.push({
                    value: '#000000'
                })
            }

            $scope.showColor = function (type) {
                $element.find('#' + type + '-input-color').click()
            }

            $scope.init = function () {
                const imageInput = $element.find('.logoUserInput')[0];
                const previewImage = $element.find('.logoUserImagePreview')[0];

                imageInput.addEventListener('change', (event) => {
                    const file = event.target.files[0];
                    const reader = new FileReader();

                    reader.onload = () => {
                        const base64String = reader.result;
                        previewImage.src = base64String;

                        $timeout(function () {
                            $scope.detectColors()
                        })
                    };
                    reader.readAsDataURL(file);
                });

            }
            $scope.state = {
                tab: 'theme',
                view: {
                    customConfig: false,
                    showColors: false,
                }
            }

            $scope.showColors = function () {
                $scope.state.view.customConfig = false
                $scope.state.view.showColors = true
                track('Editor Colors Show')
            }

            $scope.hideColors = function () {
                $scope.state.view.showColors = false
                track('Editor Colors Hide')
            }

            function improveDetectedColors(colors) {
                colors.push('#000000')
                colors.push('#ffffff')
                colors = [...new Set(colors)]
                return colors
            }

            $scope.detectColors = function () {
                const colorThief = new ColorThief();
                const img = document.querySelector('img.logoUserImagePreview');

                if (img.complete) {
                    $timeout(function () {
                        $scope.detectedColors = improveDetectedColors(colorThief.getPalette(img).map(color => RGBToHEX(...color)))
                    })
                } else {
                    image.addEventListener('load', function () {
                        $timeout(function () {
                            $scope.detectedColors = improveDetectedColors(colorThief.getPalette(img).map(color => RGBToHEX(...color)))
                        })
                    });
                }
            }

            $scope.selectColor = function (color, type) {
                $scope.pallete[type] = color
                $scope.change()
            }

            $scope.changePallete = function (pallete) {
                pallete = JSON.parse(JSON.stringify(pallete))
                if (pallete.palletes) {
                    $scope.selectedPallete = pallete
                }
                for (let key of ['main', 'text', 'highlight']) {
                    $scope.pallete[key] = pallete[key]
                }

                $scope.change()
                track('Editor Pallete Click', {
                    color: pallete.name
                })
            }

            $scope.addNewPallete = function () {
                $scope.palletes.push({
                    main: $scope.pallete.main,
                    text: $scope.pallete.text,
                    highlight: $scope.pallete.highlight,
                })

                // Mark last as editing
                $scope.palletes[$scope.palletes.length - 1].editing = true
                $scope.palletes[$scope.palletes.length - 1].isNew = true
                $scope.onStartEditing($scope.palletes.length - 1)
            }

            $scope.apply = function (index) {
                const pallete = $scope.palletes[index]
                $scope.pallete.main = pallete.main
                $scope.pallete.text = pallete.text
                $scope.pallete.highlight = pallete.highlight
                $scope.change()
            }

            $scope.remove = function (index, params) {
                showConfirm(gettext('label.are_you_sure'), null, function (status) {
                    if (status) {
                        $scope.palletes.splice(index, 1)
                        $scope.change()
                    }
                })
            }
            $scope.cancelAdd = function (index) {
                $scope.palletes.splice(index, 1)
                $scope.change()
            }

            $scope.onStartEditing = function (index) {
                $scope.currentEditingIndex = index
            }

            $scope.onEndEditing = function (index) {
                $scope.currentEditingIndex = null

                $scope.updateColorsFromPalletes()
            }

            $scope.updateColorsFromPalletes = function () {
                let currentColors = $scope.colors

                for (let pallete of $scope.palletes) {
                    for (let key of ['main', 'text', 'highlight']) {
                        if (!currentColors.find(color => color.value == pallete[key])) {
                            currentColors.push({
                                value: pallete[key]
                            })
                        }
                    }
                }
                $scope.change()
            }

        }
    }
})

app.directive('ngScroll', function () {
    return {
        restrict: 'A',
        scope: {
            ngScroll: '&',
            ngScrollOffset: '@'
        },
        link: function (scope, element) {
            element.bind('scroll', function () {
                var scrollHeight = element[0].scrollHeight;
                var scrollTop = element[0].scrollTop;
                var clientHeight = element[0].clientHeight;
                var offset = parseInt(scope.ngScrollOffset) || 0;

                if (scrollHeight - scrollTop - offset <= clientHeight) {
                    scope.$apply(scope.ngScroll);
                }
            });
        }
    };
});

app.directive('galilaiCanvas', function () {
    return {
        restrict: 'E',
        scope: {
            editItem: '=',
            edit: '=',
            content: '=',
            extraInfo: '=',
            action: '=',
            visuals: '=',
            histories: '=',
            fonts: '=',
            theme: '=',
            canEdit: '=',
        },
        controller: function ($scope, $element, $attrs, $sce, $rootScope, $timeout, fontsService) {
            $scope.isCalendar = $rootScope.isCalendar;
            $scope.isEditor = $rootScope.isEditor;

            $scope.searchFontVisible = false

            $scope.actions = []
            $scope.showCustomActions = []

            $scope.hideAction = function ($index, $event) {
                $event.stopPropagation()
                $event.preventDefault()
                $scope.visuals[$index].currentAction = null
            }

            $scope.toggleCustomActions = function ($index, $event) {
                $scope.showCustomActions[$index] = !$scope.showCustomActions[$index]
                if ($scope.showCustomActions[$index]) {
                    function closeOnClickOutside(event) {
                        $scope.toggleCustomActions($index, event)
                        document.removeEventListener('click', closeOnClickOutside)
                    }
                    document.removeEventListener('click', closeOnClickOutside)
                    document.addEventListener('click', closeOnClickOutside)
                }
                $event.stopPropagation()
                $event.preventDefault()
            }

            $scope.showAction = function ($index, kind, $event) {
                $event.stopPropagation()
                $event.preventDefault()
                $scope.visuals[$index].currentAction = kind
            }

            $scope.getFontName = function (font) {
                return fontsService.getFontName(font)
            }

            $rootScope.$on('closeAction', function (event, data) {
                if (!data || typeof data.id == 'undefined') {
                    return
                }
                if (!$scope.visuals[parseInt(data.id)]) {
                    return
                }
                $scope.visuals[parseInt(data.id)].currentAction = null
            })

            $rootScope.$on('showAction', function (event, data) {
                if (!data || typeof data.id == 'undefined' || typeof data.kind == 'undefined') {
                    return
                }
                if (!$scope.visuals[parseInt(data.id)]) {
                    return
                }
                $scope.visuals[parseInt(data.id)].currentAction = data.kind
            })

            $scope.getCurrentAction = function ($index) {
                return $scope.visuals[$index] && $scope.visuals[$index].currentAction
            }

            $scope.isText = function ($index) {
                let textTypes = ['p-', 'h1-', 'span-']
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return textTypes.some(type => $scope.visuals[$index].getSelected().elementId.startsWith(type))
            }

            $scope.isRect = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return $scope.visuals[$index].getSelected().elementId.startsWith('rect-')
            }

            $scope.isElement = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                return !$scope.isText($index) && !$scope.isRect($index) && !$scope.isImage($index)
            }

            $scope.isImage = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                let selected = $scope.visuals[$index].getSelected()
                if (!selected) {
                    return
                }
                return selected.elementId.startsWith('image-') && selected.kind != 'video'
            }

            $scope.isVideo = function ($index) {
                if (!$scope.visuals[$index] || !$scope.visuals[$index].getSelected() || !$scope.visuals[$index].getSelected().elementId) {
                    return
                }
                let selected = $scope.visuals[$index].getSelected()
                if (!selected) {
                    return
                }
                return selected.kind == 'video'
            }

            $scope.hasOverlayImage = function ($index) {
                return $scope.isImage($index)
            }

            $scope.showCustomFont = function ($event) {
                $event.stopPropagation()
                $event.preventDefault()

                $scope.searchFontVisible = true
                $timeout(function () {
                    let parent = $event.target.parentElement
                    let input = parent.querySelector('autocomplete input')
                    if (input) {
                        input.focus()
                    }
                }, 100)
            }
        },
        templateUrl: "canvas.html",
    };
});

app.directive('onEnter', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.bind('keydown', function (event) {
                if (event.keyCode === 13) {  // 13 is the Enter key code
                    scope.$apply(function () {
                        scope.$eval(attrs.onEnter);
                    });
                }
            });
        }
    };
});

app.directive('deferredModelUpdate', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModelCtrl) {
            var isEditing = false;
            var originalValue;

            // When the input gains focus, stop updating the model
            element.on('focus', function () {
                isEditing = true;
                originalValue = ngModelCtrl.$viewValue;
            });

            // Prevent updating the model while the user is typing
            element.on('input', function (event) {
                if (isEditing) {
                    event.stopImmediatePropagation();
                    event.preventDefault();
                    ngModelCtrl.$setViewValue(originalValue);
                }
            });

            // When the user presses Enter update the model
            element.on('blur keypress', function (event) {
                if (event.type === 'keypress' && event.which === 13) {
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(element.val());
                        ngModelCtrl.$render();
                        originalValue = element.val()
                    });

                    if (attrs.ngChange) {
                        scope.$eval(attrs.ngChange);
                    }
                } else if (event.type === 'blur') {
                    // On blur, update the model with original value
                    scope.$apply(function () {
                        ngModelCtrl.$setViewValue(originalValue);
                        ngModelCtrl.$render();
                    })
                }
            });

            ngModelCtrl.$render = function () {
                element.val(ngModelCtrl.$viewValue);
            };
        }
    };
});

app.directive('fileInput', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('change', function (event) {
                var file = event.target.files[0];
                if (file) {
                    var uploadImageFn = $parse(attrs.fileInput);
                    scope.$apply(function () {
                        uploadImageFn(scope, { $file: file });
                    });

                    // Reset the input value to allow re-uploading the same file
                    event.target.value = null;
                }
            });
        }
    };
}])

app.directive('filesInput', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('change', function (event) {
                var files = event.target.files;
                if (files.length) {
                    var uploadImageFn = $parse(attrs.filesInput);
                    scope.$apply(function () {
                        uploadImageFn(scope, { $files: files });
                    });

                    // Reset the input value to allow re-uploading the same files
                    event.target.value = null;
                }
            });
        }
    };
}]);

app.directive('container', function () {
    return {
        restrict: 'E',
        scope: {
            config: '=',
            index: '=',
        },
        controller: function ($scope, $element, $attrs, $sce) {
        },
        templateUrl: "container.html",
    };
});

function getCurrentProjectInfo({project, social, profile}) {
    let global = project?.global || {};
    let updated = {
        area: global?.area || social?.area,
        category: global?.category || social?.category,
        handle: global?.content?.author?.handle || social?.handle,
        logo: global?.content?.author?.logo,
        image: global?.content?.author?.image || social?.image,
        name: global?.content?.author?.name || social?.name,
        bio: profile || social?.bio,
    }
    // Remove undefined'null values
    Object.keys(updated).forEach(key => {
        if (updated[key] === undefined || updated[key] === null) {
            delete updated[key];
        }
    });
    return updated;
}

app.run(function ($rootScope, $http, experiments, api, $timeout, $interval) {

    console.log('Running app')
    $rootScope.isLoggedIn = isLoggedIn()

    // Shared credit balance: the dashboard, the design mode picker and the model type
    // modal all show the same number, so it lives on the rootScope instead of being
    // fetched by each controller.
    //
    // Prices come from the server with the balance. They are business values living in
    // credits.yml, and the literals below are only a fallback for the moment before the
    // first response — never the source of truth. Duplicating them here is what let the
    // video price quote 10 a second while the server charged 15.
    $rootScope.creditsCost = null
    $rootScope.creditsPerPost = 10
    $rootScope.creditsBalance = null
    // The durations the video screens offer, shipped with the balance for the same reason
    // the prices are. The literal below is only the moment before the first response.
    $rootScope.videoDurations = [3, 5, 10, 15]

    // Per second of generated video. Read through a getter because the video controllers
    // ask for it on every duration change, long after this ran.
    $rootScope.getCreditsPerSecond = function () {
        let value = $rootScope.creditsCost && $rootScope.creditsCost.video_per_second
        return typeof value == 'number' ? value : 25
    }

    // What a video of this length costs. Both video screens quote it, and both compare it
    // against the balance before letting the user spend.
    $rootScope.getVideoCreditsFor = function (duration) {
        return (duration || 0) * $rootScope.getCreditsPerSecond()
    }

    // The video screens keep their own copy of the balance, fetched when they open. They
    // pass it in; everything else falls back to the shared one.
    function videoBalance(balance) {
        return typeof balance == 'number' ? balance : $rootScope.creditsBalance
    }

    // Whether a video of this length can be paid for. An unknown balance answers true: the
    // server check stands behind this, and blocking on a number we failed to fetch would
    // turn a network hiccup into a dead button.
    $rootScope.canAffordVideoDuration = function (duration, balance) {
        let credits = videoBalance(balance)
        if (typeof credits != 'number') {
            return true
        }
        return $rootScope.getVideoCreditsFor(duration) <= credits
    }

    // The longest offered duration the balance covers, or null when even the shortest one
    // does not fit.
    $rootScope.getAffordableVideoDuration = function (balance) {
        let credits = videoBalance(balance)
        if (typeof credits != 'number') {
            return null
        }
        let affordable = ($rootScope.videoDurations || []).filter(function (duration) {
            return $rootScope.getVideoCreditsFor(duration) <= credits
        })
        return affordable.length ? Math.max.apply(null, affordable) : null
    }

    // The message the video screens show instead of letting the user press generate. It
    // names the length that does fit, because "not enough credits" alone leaves the person
    // guessing which button to press.
    $rootScope.getVideoCreditsWarning = function (duration, balance) {
        if (!duration || $rootScope.canAffordVideoDuration(duration, balance)) {
            return ''
        }
        let affordable = $rootScope.getAffordableVideoDuration(balance)
        if (affordable) {
            return gettext('postgen.credits_short_suggest')
                .replace('%s', duration)
                .replace('%s', affordable)
        }
        return gettext('postgen.credits_short')
            .replace('%s', duration)
            .replace('%s', $rootScope.getVideoCreditsFor(duration))
    }

    $rootScope.refreshCreditsBalance = function () {
        if (!isLoggedIn()) {
            return
        }
        api.getCurrentCredits().then(function (res) {
            $rootScope.creditsBalance = res?.data?.credits
            if (res?.data?.cost) {
                $rootScope.creditsCost = res.data.cost
                if (typeof res.data.cost.post == 'number') {
                    $rootScope.creditsPerPost = res.data.cost.post
                }
            }
            if (Array.isArray(res?.data?.videoDurations) && res.data.videoDurations.length) {
                $rootScope.videoDurations = res.data.videoDurations
            }
            $timeout(angular.noop)
        }).catch(function (err) {
            // The balance is informative: without it the copy simply omits the number.
        })
    }

    $rootScope.$on('onUserData', function () {
        $rootScope.refreshCreditsBalance()
    })
    $rootScope.$on('credits.updated', function () {
        $rootScope.refreshCreditsBalance()
    })
    $rootScope.$on('credits.refresh', function () {
        $rootScope.refreshCreditsBalance()
    })

    $rootScope.refreshCreditsBalance()

    function getCreditsBalanceLabel() {
        if (typeof $rootScope.creditsBalance != 'number') {
            return ''
        }
        return gettext('design_mode.note_balance').replace('%s', $rootScope.creditsBalance)
    }

    function joinWithBalance(text) {
        let balance = getCreditsBalanceLabel()
        return balance ? text + ' · ' + balance : text
    }

    $rootScope.getProfessionalModeHint = function () {
        return gettext('design_mode.professional_hint').replace('%s', $rootScope.creditsPerPost)
    }

    $rootScope.getStandardModeNote = function () {
        return joinWithBalance(gettext('design_mode.note_standard'))
    }

    $rootScope.getProfessionalCreditsNote = function () {
        return joinWithBalance(gettext('design_kind.professional_credits').replace('%s', $rootScope.creditsPerPost))
    }

    $rootScope.getCreateContentNote = function () {
        let note = gettext('dashboard.create_note')
        if (typeof $rootScope.creditsBalance != 'number') {
            return note
        }
        return note + ' · ' + gettext('dashboard.create_note_balance').replace('%s', $rootScope.creditsBalance)
    }

    $rootScope.isCancelled = function () {
        return $rootScope?.userConfig?.billing?.status == 'cancelled'
    }
    $rootScope.waitForUserConfig = function(callback) {
        var elapsed = 0;
        var interval = $interval(function() {
            elapsed += 300;

            if ($rootScope.userConfig && Object.keys($rootScope.userConfig).length > 0) {
                console.log('User config loaded after', elapsed, 'ms');
                $interval.cancel(interval);
                callback(true);
            } else if (elapsed >= 15000) {
                $interval.cancel(interval);
                callback(false); // timed out
            }
        }, 300);
    };
    $rootScope.IAPEnabled = function () {
        if ($rootScope.userConfig && $rootScope.userConfig.billing && $rootScope.userConfig.billing.source && $rootScope.userConfig.billing.source != 'iap') {
            return false
        }
        return IS_APP && IS_IOS
    }

    $rootScope.checkReviewFeature = function (feature) {
        if (!feature) {
            return
        }
        const mapCount = {
            'download_or_schedule': 2,
        }
        if (!mapCount[feature]) {
            return
        }
        try {
            if (!(IS_APP && IS_IOS)) {
                return false
            }
            if (safeGetStorage('app.asked_review')) {
                return false
            }
            let featureCount = safeGetStorage('feature.usage.' + feature)
            if (!featureCount) {
                featureCount = 0
            }
            featureCount = parseInt(featureCount)
            if (isNaN(featureCount)) {
                featureCount = 0
            }
            featureCount += 1
            localStorage.setItem('feature.usage.' + feature, featureCount)

            if (featureCount < mapCount[feature]) {
                return false
            }
            showConfirm(gettext('label.ask_review'), null, function(status) {
                if (!status) {
                    return
                }
                localStorage.setItem('app.asked_review', 'true')
                sendMessageWithCallback({
                    name: 'askReview',
                })
            })
        } catch (e) {
            console.log('Error checking review feature', e)
        }
    }

    $rootScope.getIAPSubscription = async function (userId) {
        $rootScope.externalCheckout = IS_APP && !$rootScope.IAPEnabled()
        if (!$rootScope.IAPEnabled()) {
            return
        }
        try {
            let response = await sendMessageWithCallback({
                name: 'getActivePlan',
                userId: userId,
            })
            if (response && response.result && response.result.active && response.result.id) {
                if (!$rootScope.userConfig) {
                    $rootScope.userConfig = {}
                }
                if (!$rootScope.userConfig.billing) {
                    $rootScope.userConfig.billing = {}
                }
                $rootScope.userConfig.billing.plan = response.result
                $rootScope.userConfig.billing.customer = true
                delete $rootScope.userConfig.billing.expired
            }
            $timeout(angular.noop)
        } catch (e) {
            console.log('Error getting IAP subscription', e)
        }
    }

    $rootScope.appURL = window.BASE_URL
    function generateCheckoutHash() {
        $rootScope.userTempID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        $rootScope.checkoutURL = $rootScope.appURL + '/api/checkout/' + $rootScope.userTempID
    }

    generateCheckoutHash()

    function showUpdateMessage(preventClose) {
        let message = preventClose ? gettext('label.app_update_available_required') : gettext('label.app_update_available')
        showSuccess(message)

        setTimeout(function () {
            if (preventClose) {
                let element = document.querySelector('#successModal')
                element.querySelector('button').remove()

                let modal = angular.element(element)
                modal.css('pointer-events', 'none')
            }
        }, 100)
    }

    async function doIAP(data) {
        if (!data || !data.user || !data.user._id) {
            showError(gettext('error.generic'))
            return
        }
        let loading = showLoading()
        try {
            let userId = data.user._id
            let response = await sendMessageWithCallback({
                name: 'makePurchase',
                userId: userId,
            })
            if (response && response.result && response.result.error) {
                if (response.result.error == 'another_user') {
                    showError(gettext('error.iap_other_account'))
                } else if (response.error == 'purchase_cancelled') {
                    // Do nothing
                } else {
                    showError(gettext('error.generic'))
                }
            } else {
                if (response && response.result && response.result.active) {
                    showSuccess(gettext('success.generic'))
                    setTimeout(function () {
                        reloadLocation(true)
                    }, 1000)
                } else {
                    showError(gettext('error.generic'))
                }
            }

            $rootScope.getIAPSubscription(userId)
        } catch (e) {
            showError(gettext('error.generic'))
        } finally {
            loading()
        }
    }

    if (!IS_APP) {
        $rootScope.isBootstraped = true
        $rootScope.startWithLogin = false
    } else {
        $rootScope.startWithLogin = false

        function startApp(withLogin, source) {
            console.log('Starting app', source, withLogin)
            $rootScope.isBootstraped = true
            // Always start without login now
            $rootScope.startWithLogin = false

            $timeout(angular.noop)
        }

        function compareBuildVersions(v1, v2) {
            if (typeof v1 == 'undefined' || typeof v2 == 'undefined' || v1 == null || v2 == null) {
                return '='
            }
            try {
                // Consider if is ios or android
                let os = window.navigator.userAgent.toLowerCase()
                if (os.indexOf('android') > -1) {
                    let build1 = parseInt(v1)
                    let build2 = parseInt(v2)
                    if (build1 > build2) {
                        return '>'
                    } else if (build1 < build2) {
                        return '<'
                    }
                    return '='
                }
                // iOS needs to compare the build number
                let v1Parts = v1.split('.')
                let v2Parts = v2.split('.')

                for (let i = 0; i < v1Parts.length; i++) {
                    if (parseInt(v1Parts[i]) > parseInt(v2Parts[i])) {
                        return '>'
                    }
                    if (parseInt(v1Parts[i]) < parseInt(v2Parts[i])) {
                        return '<'
                    }
                }
            } catch (e) {
                console.log('Error comparing versions', e)
            }
            return '='
        }

        function showUpdateApp(version) {
            let alreadyShown = localStorage.getItem('showed_update.' + version)
            const preventContinueUsing = alreadyShown
            if (preventContinueUsing) {
                showUpdateMessage(true)
                return
            }
            if (!alreadyShown) {
                localStorage.setItem('showed_update.' + version, 'true')
            }
            showUpdateMessage(false)
        }

        function checkVersion(info) {
            if (!info || !info.build) {
                startApp(false, 'no_build')
                return
            }
            api.getGlobalConfig('mobile_app_version').then(res => {
                let currentOS = window.navigator.userAgent.toLowerCase().indexOf('android') > -1 ? 'android' : 'ios'
                if (!res.data.value || typeof res.data.value[currentOS] == 'undefined') {
                    startApp(false, 'no_server_version')
                    return
                }
                let publishedVersion = res.data.value[currentOS].toString()
                let compare = compareBuildVersions(info.build, publishedVersion)
                console.log('Comparing versions', info.build, publishedVersion, compare)
                if (compare == '>') {
                    startApp(true, 'new_version')
                } else {
                    startApp(false, 'same_version')

                    if (compare == '<') {
                        showUpdateApp(publishedVersion)
                    }
                }
            })
                .catch(e => {
                    console.log('Error getting version', e)
                    $timeout(function () {
                        $rootScope.errorCheckApp = true
                    })
                    startApp(false, 'error')
                })
        }
        window.addEventListener('message', function (event) {
            console.log('Received message', event.data)
            if (event.data.name === 'onBootstrap') {
                console.log('Bootstrap event', event.data)
                if (!event.data || !event.data.data || !event.data.data.info) {
                    startApp(false, 'no_info')
                    return
                }
                checkVersion(event.data.data.info)
            }
        });
        if (window.APP_BOOTSTRAPED) {
            console.log('App already bootstrapped')
            checkVersion(window.APP_INFO)
        }
    }

    checkAuth()
    experiments.setupExperiments()
    let interval = setInterval(() => {
        let loading = document.getElementById('before-app-loading')
        if (!loading) {
            return
        }
        loading.remove();
        clearInterval(interval)
    }, 100)
    $rootScope.isApp = IS_APP
    $rootScope.externalCheckout = IS_APP && !$rootScope.IAPEnabled()
    $rootScope.baseEditor = window.location.origin + window.location.pathname
    $rootScope.f = {
        calendar: false,
    }

    $rootScope.setFeatures = function (features) {
        if (!features) {
            return
        }
        for (let key in features) {
            $rootScope.f[key] = features[key]
        }
    }

    $rootScope.hasFeature = function (feature) {
        if (feature == 'allow_auto_font_size') {
            return false
        }
        if (!$rootScope.f) {
            return false
        }
        return $rootScope.f[feature]
    }

    $rootScope.formatRemToPX = function (rem) {
        let base = 16
        try {
            let result = rem * base
            if (!isValidNumber(result)) {
                return '-'
            }
            return result.toFixed(1) + 'px'
        } catch (e) {
            return '-'
        }
        return '-'
    }

    let intervalCheckout = null
    $rootScope.startCheckout = function (data, params) {

        try {
            // Track google conversions
            track('Editor Begin Checkout', params)
        } catch (e) {
            console.log('Error tracking checkout', e)
        }
        try {
            if (typeof microsoftReportBeginCheckout === 'function') {
                microsoftReportBeginCheckout()
            }
        } catch (e) {
            console.log(e)
        }
        console.log('Starting checkout', data, params, $rootScope.IAPEnabled())
        if (intervalCheckout) {
            clearInterval(intervalCheckout)
        }
        if ($rootScope.IAPEnabled()) {
            doIAP(data)
            return
        }
        if (!IS_APP) {
            changeURL(data.url)
            return
        }
        if (!data.jobId) {
            // TODO - this is an error
            return
        }
        generateCheckoutHash()
        intervalCheckout = setInterval(() => {
            api.getJob(data.jobId).then(res => {
                if (res.data && res.data.status != 'pending') {
                    clearInterval(intervalCheckout)
                    if (res.data && res.data.status == 'success' && res.data.data && res.data.data.token) {
                        localStorage.setItem('auth.token', res.data.data.token)
                        reloadLocation()
                        clearInterval(intervalCheckout)
                    } else {
                        clearInterval(intervalCheckout)
                        showError(gettext('error.generic'), null, function () {
                            reloadLocation()
                        })
                    }
                }
            }).catch(e => {
                clearInterval(intervalCheckout)
                showError(gettext('error.generic'), null, function () {
                    reloadLocation()
                })
            })
        }, 2000)
    }

    function monitorDigest() {
        // Initialize variables
        var digestTimestamps = [];
        var threshold = 50; // Set your threshold here (X digests per second)
        var windowSize = 1000; // Window size in milliseconds

        // Function to check the digest rate and print an alert if it exceeds the threshold
        function checkDigestRate() {
            var now = Date.now();
            // Remove timestamps older than the rolling window
            digestTimestamps = digestTimestamps.filter(function (timestamp) {
                return (now - timestamp) <= windowSize;
            });

            // Print a warning if the rate exceeds the threshold
            if (digestTimestamps.length > threshold) {
                console.error('High digest rate detected: ' + digestTimestamps.length + ' digest cycles in the last second');
            }
            if (digestTimestamps.length > threshold * 2) {
                alert('High digest rate detected: ' + digestTimestamps.length + ' digest cycles in the last second');
            }
        }

        // Watch for digest cycles
        $rootScope.$watch(function () {
            digestTimestamps.push(Date.now());
        });

        // Set up an interval to check the digest rate periodically
        $interval(checkDigestRate, windowSize / 2);
    }

    if (_env_ && _env_ == 'DEV') {
        monitorDigest()
    }
})

function getTokenWithAlert(showAlert = true) {
    let token = localStorage.getItem('auth.token')
    if (!token) {
        if (showAlert) {
            showError(gettext('error.generic'))
        }
        return
    }
    let info = null
    try {
        info = base64Encode(`token=${token}`)
        return info
    } catch (e) {
        if (showAlert) {
            showError(gettext('error.generic'))
        }
        return
    }
}
function checkAuth() {
    try {
        let info = new URLSearchParams(window.location.search).get('info')
        let otp = new URLSearchParams(window.location.search).get('otp')
        let mobile = new URLSearchParams(window.location.search).get('mobile')
        if (!info) {
            return
        }
        // Decode base64
        try {
            info = base64Decode(info)
        } catch (e) {
            console.log('Error decoding info', e)
            return
        }
        // Info is url encoded, parse it
        info = new URLSearchParams(info)
        // Get user info
        let instagram = info.get('instagram')
        let token = info.get('token')
        let email = info.get('email')
        if (instagram) {
            localStorage.setItem('auth.user.instagram', instagram)
        }
        if (email) {
            localStorage.setItem('auth.user.email', email)
        }
        if (token) {
            localStorage.setItem('auth.token', token)
        }
        if (otp) {
            fetch(window.BASE_URL + '/api/auth/otp/verify', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    code: otp,
                    mobile: mobile,
                })
            }).then(res => res.json())
                .then(res => {
                    if (res.status == 'verified') {
                        if (mobile) {
                            showSuccess(gettext('label.otp_verified_mobile'))
                        } else {
                            showSuccess(gettext('label.otp_verified'))
                        }
                    }
                })
                .catch(e => {
                    console.log('Error verifying otp', e)
                })
        }
    } catch (e) {
        console.log('Error checking auth', e)
    }
}
function gettext(message, ...args) {
    let translated = _MESSAGES[language][message]
    if (args && args.length) {
        args.forEach((arg, index) => {
            translated = translated.replace('%s', arg)
        })
    }
    return translated
}

function uuid(
    a
) {
    return a           // if the placeholder was passed, return
        ? (              // a random number from 0 to 15
            a ^            // unless b is 8,
            Math.random()  // in which case
            * 16           // a random number from
            >> a / 4         // 8 to 11
        ).toString(16) // in hexadecimal
        : (              // or otherwise a concatenated string:
            [1e7] +        // 10000000 +
            -1e3 +         // -1000 +
            -4e3 +         // -4000 +
            -8e3 +         // -80000000 +
            -1e11          // -100000000000,
        ).replace(     // replacing
            /[018]/g,    // zeroes, ones, and eights with
            uuid            // random hex digits
        )
}

if (!localStorage.getItem('galilai.uuid')) {
    localStorage.setItem('galilai.uuid', uuid())
}

const _trans = {
    ideas: {
        profileMessages: {
            'pt': [
                'Carregando seu perfil...',
                'Entendendo sobre seu negócio...',
                'Escolhendo as melhores cores...',
                'Selecionando as fontes para você...',
                'Quase lá...',
                'Falta pouco...',
                'Estamos quase terminando...',
                'Só mais um pouquinho...',
            ],
            'en': [
                'Loading your profile...',
                'Understanding your business...',
                'Choosing the best colors...',
                'Selecting the fonts for you...',
                'Almost there...',
                'Just a little more...',
                'We are almost done...',
                'Just a little more...',
            ],
            'es': [
                'Cargando tu perfil...',
                'Entendiendo sobre tu negocio...',
                'Seleccionando los mejores colores...',
                'Seleccionando las fuentes para ti...',
                'Casi allí...',
                'Falta poco...',
                'Estamos casi terminando...',
                'Solo un poquito más...',
            ],
            'fr': [
                'Chargement de votre profil...',
                'Comprendre votre entreprise...',
                'Choisir les meilleures couleurs...',
                'Sélection des polices pour vous...',
                'Presque là...',
                'Encore un peu...',
                'Nous y sommes presque...',
                'Encore un peu...',
            ],
            'de': [
                'Laden Sie Ihr Profil...',
                'Verstehen Sie Ihr Geschäft...',
                'Wählen Sie die besten Farben...',
                'Wählen Sie die Schriftarten für Sie aus...',
                'Fast da...',
                'Nur noch ein wenig...',
                'Wir sind fast fertig...',
                'Nur noch ein wenig...',
            ],
            'it': [
                'Caricamento del tuo profilo...',
                'Comprendere la tua attività...',
                'Scegliere i migliori colori...',
                'Selezionare i font per te...',
                'Quasi arrivato...',
                'Solo un po\' di più...',
                'Siamo quasi arrivati...',
                'Solo un po\' di più...',
            ],
            'nl': [
                'Je profiel laden...',
                'Je bedrijf begrijpen...',
                'De beste kleuren kiezen...',
                'De lettertypen voor je selecteren...',
                'Bijna klaar...',
                'Nog maar een beetje...',
                'We zijn er bijna...',
                'Nog maar een beetje...',
            ],
            'da': [
                'Indlæser din profil...',
                'Forstå din virksomhed...',
                'Vælger de bedste farver...',
                'Vælger skrifttyperne for dig...',
                'Næsten der...',
                'Bare lidt mere...',
                'Vi er næsten færdige...',
                'Bare lidt mere...',
            ],
            'sv': [
                'Laddar din profil...',
                'Förstå din verksamhet...',
                'Väljer de bästa färgerna...',
                'Väljer typsnitten för dig...',
                'Nästan där...',
                'Bara lite till...',
                'Vi är nästan klara...',
                'Bara lite till...',
            ],
            'pl': [
                'Ładowanie profilu...',
                'Rozumienie twojej działalności...',
                'Wybieranie najlepszych kolorów...',
                'Wybieranie czcionek dla ciebie...',
                'Już prawie...',
                'Trochę więcej...',
                'Jesteśmy prawie gotowi...',
                'Trochę więcej...',
            ],
        }
    },
    publish: {
        helpInstagram: {
            'pt': 'https://galilai.tawk.help/article/como-conectar-instagram-no-galilai'
        },
        instructions: {
            'pt': [
                `Que sua conta do Instagram seja <a href="https://business.instagram.com/getting-started?locale=pt_BR" target="_blank">uma conta empresarial</a>`,
                `Que a conta do Instagram esteja <a href="https://pt-br.facebook.com/business/help/connect-instagram-to-page" target="_blank">conectada a uma página do Facebook</a>`,
                `Que você seja administrador da página do Facebook conectada ao Instagram`,
                `Que você tenha aceitado as permissões do GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Tente aqui novamente</a>`
            ],
            'en': [
                `Your Instagram account must be <a href="https://business.instagram.com/getting-started?locale=en_US" target="_blank">a business account</a>`,
                `Your Instagram account must be <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">connected to a Facebook page</a>`,
                `You must be an administrator of the Facebook page connected to Instagram`,
                `You must have accepted GalilAI permissions. <a id="try-again-galilai" href="javascript:void(0)"> Try here again</a>`
            ],
            'es': [
                `Su cuenta de Instagram debe ser <a href="https://business.instagram.com/getting-started?locale=es_ES" target="_blank">una cuenta empresarial</a>`,
                `Su cuenta de Instagram debe estar <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">conectada a una página de Facebook</a>`,
                `Debe ser administrador de la página de Facebook conectada a Instagram`,
                `Debe haber aceptado los permisos de GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Intente aquí nuevamente</a>`
            ],
            'fr': [
                `Votre compte Instagram doit être <a href="https://business.instagram.com/getting-started?locale=fr_FR" target="_blank">un compte professionnel</a>`,
                `Votre compte Instagram doit être <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">connecté à une page Facebook</a>`,
                `Vous devez être administrateur de la page Facebook connectée à Instagram`,
                `Vous devez avoir accepté les autorisations de GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Réessayez ici</a>`
            ],
            'de': [
                `Ihr Instagram-Konto muss <a href="https://business.instagram.com/getting-started?locale=de_DE" target="_blank">ein Geschäftskonto sein</a>`,
                `Ihr Instagram-Konto muss <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">mit einer Facebook-Seite verbunden sein</a>`,
                `Sie müssen ein Administrator der mit Instagram verbundenen Facebook-Seite sein`,
                `Sie müssen die GalilAI-Berechtigungen akzeptiert haben. <a id="try-again-galilai" href="javascript:void(0)"> Versuchen Sie es hier erneut</a>`
            ],
            'it': [
                `Il tuo account Instagram deve essere <a href="https://business.instagram.com/getting-started?locale=it_IT" target="_blank">un account aziendale</a>`,
                `Il tuo account Instagram deve essere <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">collegato a una pagina Facebook</a>`,
                `Devi essere un amministratore della pagina Facebook collegata a Instagram`,
                `Devi aver accettato i permessi di GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Riprova qui</a>`
            ],
            'nl': [
                `Je Instagram-account moet <a href="https://business.instagram.com/getting-started?locale=nl_NL" target="_blank">een zakelijk account</a> zijn`,
                `Je Instagram-account moet <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">verbonden zijn met een Facebook-pagina</a>`,
                `Je moet een beheerder zijn van de Facebook-pagina die is verbonden met Instagram`,
                `Je moet de GalilAI-machtigingen hebben geaccepteerd. <a id="try-again-galilai" href="javascript:void(0)"> Probeer hier opnieuw</a>`
            ],
            'da': [
                `Din Instagram-konto skal være <a href="https://business.instagram.com/getting-started?locale=da_DK" target="_blank">en forretningskonto</a>`,
                `Din Instagram-konto skal være <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">tilsluttet en Facebook-side</a>`,
                `Du skal være administrator af den Facebook-side, der er tilsluttet Instagram`,
                `Du skal have accepteret GalilAI-tilladelserne. <a id="try-again-galilai" href="javascript:void(0)"> Prøv her igen</a>`
            ],
            'sv': [
                `Ditt Instagram-konto måste vara <a href="https://business.instagram.com/getting-started?locale=sv_SE" target="_blank">ett företagskonto</a>`,
                `Ditt Instagram-konto måste vara <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">kopplat till en Facebook-sida</a>`,
                `Du måste vara administratör för den Facebook-sida som är kopplad till Instagram`,
                `Du måste ha accepterat GalilAI-behörigheter. <a id="try-again-galilai" href="javascript:void(0)"> Försök här igen</a>`
            ],
            'pl': [
                `Twoje konto na Instagramie musi być <a href="https://business.instagram.com/getting-started?locale=pl_PL" target="_blank">kontem firmowym</a>`,
                `Twoje konto na Instagramie musi być <a href="https://facebook.com/business/help/connect-instagram-to-page" target="_blank">połączone z stroną na Facebooku</a>`,
                `Musisz być administratorem strony na Facebooku połączonej z Instagramem`,
                `Musisz zaakceptować uprawnienia GalilAI. <a id="try-again-galilai" href="javascript:void(0)"> Spróbuj tutaj ponownie</a>`
            ]
        }
    },
    trial: {
        features: {
            'pt': [
                'Aumente sua autoridade e cresça seu perfil',
                'Milhares de ideias para posts todos os dias',
                'Edite cores, fontes, imagens e muito mais',
                'Legendas em um clique para seus posts',
            ],
            'en': [
                'Increase your authority and grow your Instagram profile',
                'Thousands of post ideas every day',
                'Edit colors, fonts, images and more',
                'One-click captions for your posts'
            ],
            'es': [
                'Aumenta tu autoridad y crece tu perfil',
                'Miles de ideas de posts todos los días',
                'Edita colores, fuentes, imágenes y mucho más',
                'Leyendas en un clic para tus posts'
            ],
            'fr': [
                'Augmentez votre autorité et développez votre profil',
                'Des milliers d\'idées de posts tous les jours',
                'Modifiez les couleurs, les polices, les images et plus encore',
                'Légendes en un clic pour vos posts'
            ],
            'de': [
                'Erhöhen Sie Ihre Autorität und wachsen Sie Ihr Profil',
                'Tausende von Post-Ideen jeden Tag',
                'Bearbeiten Sie Farben, Schriftarten, Bilder und mehr',
                'Ein-Klick-Untertitel für Ihre Posts'
            ],
            'it': [
                'Aumenta la tua autorità e fai crescere il tuo profilo',
                'Migliaia di idee di post ogni giorno',
                'Modifica colori, font, immagini e altro',
                'Sottotitoli in un clic per i tuoi post'
            ],
            'nl': [
                'Verhoog uw autoriteit en groei uw profiel',
                'Duizenden postideeën elke dag',
                'Bewerk kleuren, lettertypen, afbeeldingen en meer',
                'Eén-klik onderschriften voor uw posts'
            ],
            'da': [
                'Øg din autoritet og vækst din profil',
                'Tusindvis af postideer hver dag',
                'Rediger farver, skrifttyper, billeder og mere',
                'Én-klik billedtekster til dine indlæg'
            ],
            'sv': [
                'Öka din auktoritet och väx din profil',
                'Tusentals postidéer varje dag',
                'Redigera färger, typsnitt, bilder och mer',
                'Ett klick bildtexter för dina inlägg'
            ],
            'pl': [
                'Zwiększ swoją władzę i rozwijaj swój profil',
                'Tysiące pomysłów na posty każdego dnia',
                'Edytuj kolory, czcionki, obrazy i więcej',
                'Podpisy w jednym kliknięciu dla twoich postów'
            ]
        }
    },
    support: {
        url: {
            'en': 'https://galil.ai/contact',
            'pt': 'https://galilai.com.br/contato',
            'es': 'https://galilai.es/contacto',
            'fr': 'https://galilai.fr/contact',
            'de': 'https://galilai.de/kontakt',
            'it': 'https://galilai.it/contatto',
            'nl': 'https://galilai.nl/contact',
            'da': 'https://galilai.dk/kontakt',
            'sv': 'https://galilai.se/kontakt',
            'pl': 'https://galilai.pl/kontakt',
        },
    }
}

const countriesToCurrency = {
    "US": { name: "United States", currency: "$" },
    "CN": { name: "China", currency: "¥" },
    "JP": { name: "Japan", currency: "¥" },
    "DE": { name: "Germany", currency: "€" },
    "IN": { name: "India", currency: "₹" },
    "GB": { name: "United Kingdom", currency: "£" },
    "FR": { name: "France", currency: "€" },
    "CA": { name: "Canada", currency: "C$" },
    "IT": { name: "Italy", currency: "€" },
    "BR": { name: "Brazil", currency: "R$" },
    "RU": { name: "Russia", currency: "₽" },
    "KR": { name: "South Korea", currency: "₩" },
    "AU": { name: "Australia", currency: "A$" },
    "ES": { name: "Spain", currency: "€" },
    "MX": { name: "Mexico", currency: "MX$" },
    "ID": { name: "Indonesia", currency: "Rp" },
    "NL": { name: "Netherlands", currency: "€" },
    "SA": { name: "Saudi Arabia", currency: "﷼" },
    "TR": { name: "Türkiye (Turkey)", currency: "₺" },
    "CH": { name: "Switzerland", currency: "Fr." },
    "AR": { name: "Argentina", currency: "$" },
    "SE": { name: "Sweden", currency: "kr" },
    "PL": { name: "Poland", currency: "zł" },
    "BE": { name: "Belgium", currency: "€" },
    "TH": { name: "Thailand", currency: "฿" },
    "IE": { name: "Ireland", currency: "€" },
    "NG": { name: "Nigeria", currency: "₦" },
    "IL": { name: "Israel", currency: "₪" },
    "AT": { name: "Austria", currency: "€" },
    "NO": { name: "Norway", currency: "kr" },
    "AE": { name: "United Arab Emirates", currency: "د.إ" },
    "HK": { name: "Hong Kong (China)", currency: "HK$" },
    "MY": { name: "Malaysia", currency: "RM" },
    "SG": { name: "Singapore", currency: "S$" },
    "PH": { name: "Philippines", currency: "₱" },
    "ZA": { name: "South Africa", currency: "R" },
    "DK": { name: "Denmark", currency: "kr" },
    "CO": { name: "Colombia", currency: "$" }, // TODO - this is buggy
    "BD": { name: "Bangladesh", currency: "৳" },
    "EG": { name: "Egypt", currency: "E£" },
    "CL": { name: "Chile", currency: "$" },
    "FI": { name: "Finland", currency: "€" },
    "VN": { name: "Vietnam", currency: "₫" },
    "PT": { name: "Portugal", currency: "€" },
    "CZ": { name: "Czech Republic", currency: "Kč" },
    "RO": { name: "Romania", currency: "lei" },
    "NZ": { name: "New Zealand", currency: "NZ$" },
    "PE": { name: "Peru", currency: "S/." },
    "GR": { name: "Greece", currency: "€" },
    "IQ": { name: "Iraq", currency: "ع.د" },
    "QA": { name: "Qatar", currency: "QR" },
    "DZ": { name: "Algeria", currency: "دج" },
    "KZ": { name: "Kazakhstan", currency: "₸" },
    "HU": { name: "Hungary", currency: "Ft" },
    "AO": { name: "Angola", currency: "Kz" },
    "KW": { name: "Kuwait", currency: "KD" },
    "MA": { name: "Morocco", currency: "MAD" },
    "UA": { name: "Ukraine", currency: "₴" },
    "EC": { name: "Ecuador", currency: "$" },
    "SK": { name: "Slovakia", currency: "€" },
    "LK": { name: "Sri Lanka", currency: "Rs" },
    "KE": { name: "Kenya", currency: "KSh" },
    "PR": { name: "Puerto Rico", currency: "$" },
    "PA": { name: "Panama", currency: "B/." },
    "DO": { name: "Dominican Republic", currency: "RD$" },
    "ET": { name: "Ethiopia", currency: "Br" },
    "GT": { name: "Guatemala", currency: "Q" },
    "OM": { name: "Oman", currency: "ر.ع." },
    "LU": { name: "Luxembourg", currency: "€" },
    "GH": { name: "Ghana", currency: "GH₵" },
    "UZ": { name: "Uzbekistan", currency: "so’m" },
    "BG": { name: "Bulgaria", currency: "лв" },
    "MM": { name: "Myanmar", currency: "K" },
    "HR": { name: "Croatia", currency: "€" },
    "TZ": { name: "Tanzania", currency: "TSh" },
    "BY": { name: "Belarus", currency: "Br" },
    "CR": { name: "Costa Rica", currency: "₡" },
    "SI": { name: "Slovenia", currency: "€" },
    "LT": { name: "Lithuania", currency: "€" },
    "MO": { name: "Macao (China)", currency: "MOP$" },
    "TN": { name: "Tunisia", currency: "د.ت" },
    "RS": { name: "Serbia", currency: "дин." },
    "TM": { name: "Turkmenistan", currency: "T" },
    "JO": { name: "Jordan", currency: "JD" },
    "UG": { name: "Uganda", currency: "USh" },
    "CI": { name: "Côte d'Ivoire", currency: "CFA" },
    "AZ": { name: "Azerbaijan", currency: "₼" },
    "LY": { name: "Libya", currency: "ل.د" },
    "CD": { name: "Congo, Dem. Rep.", currency: "FC" },
    "BO": { name: "Bolivia", currency: "Bs." },
    "BH": { name: "Bahrain", currency: ".د.ب" },
    "CM": { name: "Cameroon", currency: "CFA" },
    "PY": { name: "Paraguay", currency: "₲" },
    "LV": { name: "Latvia", currency: "€" },
    "EE": { name: "Estonia", currency: "€" },
    "ZM": { name: "Zambia", currency: "K" },
    "NP": { name: "Nepal", currency: "रु" },
    "HN": { name: "Honduras", currency: "L" },
    "CY": { name: "Cyprus", currency: "€" },
    "AF": { name: "Afghanistan", currency: "؋" }
}

function HistoryManager(initialState) {
    // Initialize stacks for undo and redo history
    var undoStack = [];
    var redoStack = [];

    // Set the initial state
    var currentState = JSON.parse(JSON.stringify(initialState));

    let debounceTimeout = null;
    const debounceTimer = 300;
    const DEBUG = window.location.hostname === 'localhost';
    // Method to perform an action and update state
    this.add = function (newState, debounce = false) {

        function add() {
            // Push the current state to the undo stack
            undoStack.push(JSON.parse(JSON.stringify(currentState)));

            // Clear the redo stack on new action
            redoStack = [];

            // Update the current state with new values
            currentState = JSON.parse(JSON.stringify(newState));
            if (DEBUG) {
                console.log("Performed action, new state:", currentState);
            }
        }

        if (debounce) {
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(() => {
                add();
            }, debounceTimer);
        } else {
            add();
        }
    };


    // Method to undo the last action
    this.undo = function () {
        if (undoStack.length > 0) {
            // Push the current state to the redo stack
            redoStack.push(JSON.parse(JSON.stringify(currentState)));

            // Pop the last state from the undo stack
            currentState = undoStack.pop();
            if (DEBUG) {
                console.log("Undo performed, current state:", currentState);
            }
        }
    };

    // Method to redo the last undone action
    this.redo = function () {
        if (redoStack.length > 0) {
            // Push the current state to the undo stack
            undoStack.push(JSON.parse(JSON.stringify(currentState)));

            // Pop the last state from the redo stack
            currentState = redoStack.pop();
            if (DEBUG) {
                console.log("Redo performed, current state:", currentState);
            }
        }
    };

    this.canUndo = function () {
        return undoStack.length > 0;
    };

    this.canRedo = function () {
        return redoStack.length > 0;
    }

    // Method to get the current state
    this.getState = function () {
        return JSON.parse(JSON.stringify(currentState));
    };
}


/* Ebook materials manager */
function renderDownloadBanner(wrapperId, title, description, url) {
  const wrapper = document.getElementById(wrapperId);

  if (!wrapper) {
    console.error("Wrapper element not found:", wrapperId);
    return;
  }

  // Create banner container
  const banner = document.createElement("div");
  banner.className =
    "alert border-0 shadow-sm d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 p-4 rounded-4 my-4";
  banner.style.background = "rgba(111, 66, 193, 0.08)";

  // Banner HTML
  banner.innerHTML = `
    <div class="d-flex align-items-start gap-3">

      <!-- MDI Icon -->
      <div class="flex-shrink-0">
        <i class="mdi mdi-book-open-page-variant text-primary fs-2"></i>
      </div>
      <div>
        <h5 class="mb-1 fw-semibold text-dark">
          ${title}
        </h5>
        <p class="mb-0 text-muted" style="display: block!important; font-size: 14px!important;">
          ${description}
        </p>
      </div>
    </div>
    <div>
      <a
        href="${url}"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-primary btn-lg px-4 rounded-3 download-link"
      >
        <i class="mdi mdi-download me-2"></i>
        Baixar material
      </a>
    </div>
  `;

  // Insert banner into wrapper
  wrapper.prepend(banner);

  // Click handler ONLY for dismissing
  const link = banner.querySelector(".download-link");

  link.addEventListener("click", function () {
    // Remove banner after click
    banner.remove();
  });
}

function insertBannerWrapper() {
  const target = document.querySelector("#header-creator-top > .container > .row");

  if (!target) {
    return null;
  }

  // Create wrapper div
  const wrapper = document.createElement("div");
  wrapper.id = "bannerWrapper";

  // Insert wrapper BEFORE target element
  target.parentNode.insertBefore(wrapper, target);

  return wrapper.id;
}


async function checkAndRenderEbook() {
  try {
    // Read query param ebook
    const params = new URLSearchParams(window.location.search);
    const ebookId = params.get("ebook");

    // If no ebook param → do nothing
    if (!ebookId) {
      return false;
    }

    let wrapperId = insertBannerWrapper()

    // Fetch ebook data from backend
    const response = await fetch(`/pt/ebook/${ebookId}`);

    if (!response.ok) {
      console.error("Ebook fetch failed:", response.status);
      return false;
    }

    const data = await response.json();

    // Validate required fields
    if (!data || !data.title || !data.description || !data.url) {
      console.error("Invalid ebook response:", data);
      return false;
    }

    // Render banner
    renderDownloadBanner(
      wrapperId,
      data.title,
      data.description,
      data.url
    );

    return true;
  } catch (error) {
    console.error("checkAndRenderEbook error:", error);
    return false;
  }
}

checkAndRenderEbook()